/* ===========================================================================
   ⚑ BUILD STAMP AND A SELF-DIAGNOSTIC — added 24 Aug 2026
   ===========================================================================
   Finbar reported the price filter failing on the second change and showing
   products underneath "Nothing matches all of those filters". ⚑ TWELVE
   SEQUENCES ACROSS TWO PAGE TYPES COULD NOT REPRODUCE IT — every state came
   back consistent, which makes the difference environmental rather than
   logical, and the likeliest candidate is a CACHED COPY OF THIS FILE.

   ⚑ SHOPIFY'S `asset_url` CACHE-BUSTS ON CONTENT, BUT THE PAGE HTML CARRIES
   THE OLD HASHED URL IF THE HTML ITSELF IS CACHED. A normal reload can
   therefore keep serving yesterday's script while a fresh URL serves today's,
   which is exactly the "works on first entry, fails after" shape.

   So the file now says which build it is, and can describe its own state:
     HCS_BP_BUILD              -> the build string, read it in the console
     HCS_BP_DEBUG()            -> counts and, crucially, whether the empty
                                  message and painted cards CONTRADICT
   Both are read-only and cost nothing.
=========================================================================== */
window.HCS_BP_BUILD = '2026-09-10T19:10Z';
window.HCS_BP_DEBUG = function () {
  var all = Array.prototype.slice.call(document.querySelectorAll('[data-bp-card]'));
  var painted = all.filter(function (c) { return c.offsetParent !== null; });
  var emptyCls = !!document.querySelector('.hcs-bp--empty');
  var lo = document.querySelector('.hcs-bp__range-in[data-r=lo]');
  var hi = document.querySelector('.hcs-bp__range-in[data-r=hi]');
  var out = {
    build: window.HCS_BP_BUILD,
    cards: all.length,
    painted: painted.length,
    emptyMessageShowing: emptyCls,
    /* ⚑ THE ONE THAT MATTERS. True means the page is telling the shopper
       nothing matched while still painting products - the exact fault. */
    CONTRADICTION: emptyCls && painted.length > 0,
    priceBox: lo && hi ? (lo.value + ' to ' + hi.value) : 'none',
    overCeiling: 0
  };
  if (hi) {
    var cap = parseFloat(hi.value) * 100;
    out.overCeiling = painted.filter(function (c) {
      var s = c.querySelector('[data-bp-select]');
      var cur = s ? s.options[s.selectedIndex] : null;
      var cents = cur ? parseInt(cur.getAttribute('data-cents'), 10)
                      : parseInt(c.getAttribute('data-bp-min'), 10);
      return cents > cap;
    }).length;
  }
  console.log('HCS filter state', out);
  return out;
};

/* HCS sub-category pages - FILTER, SORT AND VIEW (19 Aug 2026, desk 08).
 *
 * Finbar: "every single sub cat and Search also needs the option to filter and
 * sort, switching the user to list view with the pull out from the left to
 * filter and a standard drop down to sort. this is the classic way and cannot
 * be ignored."
 *
 * WHAT IT DOES
 *   Filter  - a tray, pop-out from the left under 990px, a sticky sidebar over.
 *             Every facet is DERIVED FROM THE CARDS ON THE PAGE, so it can
 *             never offer a value that filters to nothing.
 *   Sort    - a native <select>. Featured (the server order), price both ways,
 *             name both ways.
 *   View    - Grid or List, remembered in localStorage.
 *
 * THE ONE STRUCTURAL DECISION. Choosing a sort or a filter COLLAPSES the
 * curated bands into a single flat list. Sorting by price while the page is
 * still grouped into "600W kits" and "Ballasts and parts" is not a sort - the
 * cheapest thing on the page can still be the last card on the screen. Clearing
 * everything puts every card back in its own band, in its original order.
 *
 * THE CARDS ARE NEVER RE-RENDERED. Flattening MOVES the existing nodes, so a
 * size already chosen in a dropdown survives sorting, filtering and switching
 * view. It is also why every card records where it came from before it moves.
 *
 * IF THIS FILE FAILS TO LOAD the control row stays `hidden`, the bands render
 * as they always did and every product is still buyable. A control that is
 * visible and does nothing is worse than no control.
 */
(function () {
  'use strict';

  function txt(el) { return (el && el.textContent || '').trim(); }
  function money(p) { return '£' + (p / 100).toFixed(p % 100 === 0 ? 0 : 2); }

  /* Price buckets in PENCE - data-bp-min is Shopify's integer minor units, the
   * same as data-bp-max, which the existing sort already treats as an int. */
  var BANDS = [
    { id: 'p1', label: 'Under £25',      lo: 0,     hi: 2500 },
    { id: 'p2', label: '£25 to £50',   lo: 2500,  hi: 5000 },
    { id: 'p3', label: '£50 to £100',  lo: 5000,  hi: 10000 },
    { id: 'p4', label: '£100 to £250', lo: 10000, hi: 25000 },
    { id: 'p5', label: '£250 and over',  lo: 25000, hi: Infinity }
  ];

  function init(root) {
    var scope = root.querySelector('[data-bp-bands]');
    var bar = root.querySelector('[data-bp-controls]');
    if (!scope || !bar) return;

    var col = scope.querySelector('.hcs-bp__bandcol') || scope;
    var cards = Array.prototype.slice.call(scope.querySelectorAll('[data-bp-card]'));
    if (!cards.length) return;

    /* ---- remember where every card lives, before anything moves ---------- */
    /* ⚑ AND REMEMBER THE UNFILTERED PRICE SPAN. `pick()` REWRITES data-bp-min
     * AND data-bp-max to the variant it selected, so once a size or a price
     * has been chosen those attributes no longer describe the product - they
     * describe one variant of it. Reading them back in the price test made the
     * filter narrow itself on every keystroke: drag the max down once and the
     * cards that survived had their span collapsed to a single price, so the
     * next drag threw them out for a reason that was no longer true.
     *
     * Cached ONCE, here, before anything can touch them. The test reads the
     * cache; the sort still reads the live attribute, which is the point of
     * the pick. */
    cards.forEach(function (c) {
      c._bpHome = c.parentNode;
      c._bpIndex = Array.prototype.indexOf.call(c.parentNode.children, c);
      var band = c.closest('.hcs-bp__band');
      c._bpBand = band ? (band.id || '') : '';
      c._bpBandName = band ? txt(band.querySelector('.hcs-bp__band-head')) : '';
      c._bpMin0 = parseInt(c.getAttribute('data-bp-min'), 10) || 0;
      c._bpMax0 = parseInt(c.getAttribute('data-bp-max'), 10) || c._bpMin0;
      /* ⚑ EVERY VARIANT PRICE, NOT JUST THE TWO ENDS. An overlap test on the
       * floor and the ceiling says the VivoSun AeroZesh - £88, £108, £178,
       * £359, £399 - is buyable for £250 to £350. It is not: there is nothing
       * between £178 and £359. The select already carries every price in
       * data-cents, so the test can ask the real question, "is there a variant
       * at a price the shopper asked for", instead of approximating it.
       *
       * null means there is no select to read - a spares link-card, which has
       * no buy control at all - and the test falls back to the span. */
      var bpSel = c.querySelector('[data-bp-select]');
      if (bpSel) {
        c._bpPrices = Array.prototype.slice.call(bpSel.options)
          .map(function (o) { return parseInt(o.getAttribute('data-cents'), 10); })
          .filter(function (n) { return n > 0; });
        if (!c._bpPrices.length) c._bpPrices = null;
      } else if (c._bpMin0 > 0 && c._bpMin0 === c._bpMax0) {
        c._bpPrices = [c._bpMin0];
      } else {
        c._bpPrices = null;
      }
      /* ⚑ AND REMEMBER WHICH SIZE THE CARD OPENED ON (23 Sep 2026).
       * Everything else a pass can disturb was already cached above - the home
       * node, the index, the price span, the area - but not the SELECTED
       * OPTION. So when the price pick switched a card to a size that fit the
       * range, Clear all restored the span, found no filter to pick against,
       * and syncDisplayedPrice() read the switched size straight back as the
       * price. Measured on live main: a £60 minimum then Clear all left 100 of
       * 142 multi-size products on Base Feeds on a different size - Sensi Bloom
       * 500g £31.45 left showing the 25lb at £391.99 - and "cheapest first"
       * then sorted on those.
       *
       * ⚑ A SIZE THE SHOPPER PICKS BECOMES THAT CARD'S STARTING SIZE. The rule
       * this engine has always had is that a size already chosen in a dropdown
       * survives sorting and filtering. A trusted change event is a person; the
       * engine's own changes are dispatched and so are never trusted - that is
       * what keeps the two apart without any bookkeeping of our own. */
      if (bpSel) {
        c._bpSel0 = bpSel.value;
        bpSel.addEventListener('change', function (e) {
          if (e.isTrusted) c._bpUserSel = bpSel.value;
        });
      }
    });

    /* The flat container the cards move into. It is a sibling of the bands so
     * restoring is a plain move back, never a re-render.
     *
     * ⚑ ON A TECHNICAL PAGE IT IS A SPEC GRID, NOT THE 4-ACROSS GRID.
     * Finbar, 21 Aug: "on these more technical pages keep that info in the
     * tile and maintain the design even after sort or filter."
     *
     * The spec card was built for a 625px column with a four-row table beside
     * the image. Dropping it into `.hcs-bp__grid` puts it in a ~300px column,
     * which is why the specs had to be hidden on sort in the first place -
     * four rows of "PPF 600 µmol/s" wrapped into a tile the width of a phone.
     * ⚑ THE FIX IS THE CONTAINER, NOT THE CARD: `.hcs-bp__specs` is one
     * column on a phone and two from 990px, the same layout the bands use, so
     * the card keeps the width it was designed for and nothing needs hiding.
     *
     * ⚑ THE TEST IS "PREDOMINANTLY", NOT "EVERY", AND THAT MATTERS.
     * `every` was the first attempt and it fired on nothing: LED Lighting is
     * 48 spec cards and TWO `lcard`s - a cables listing and a replacement
     * strip - so one accessory at the bottom of a technical page vetoed the
     * whole rule. There are THREE card snippets on this engine, not two:
     * `hcs-bp__unit` (spec), `hcs-bp__card` (grid) and `hcs-bp__lcard` (the
     * compact accessory card), and a genuinely technical page nearly always
     * carries a couple of accessories.
     *
     * Two thirds is the line. A page that is mostly grid cards keeps the old
     * behaviour, which is right for it - there the narrow column is real. The
     * handful of accessory cards on a spec page are capped in width by CSS so
     * a 12.5px title is not stretched across 400px. */
    var specCount = cards.filter(function (c) {
      return c.classList.contains('hcs-bp__unit');
    }).length;
    var allSpec = cards.length > 0 && specCount >= cards.length * 0.66;
    var flat = document.createElement('div');
    flat.className = allSpec ? 'hcs-bp__specs' : 'hcs-bp__grid';
    if (allSpec) root.classList.add('hcs-bp--specpage');
    flat.setAttribute('data-bp-flat', '');
    flat.hidden = true;
    col.appendChild(flat);

    /* =====================================================================
       ⚑ A PRICE CEILING HAS TO REACH THE DROPDOWN, NOT JUST THE CARD
       =====================================================================
       Finbar, 24 Aug: "it still shows the other variants on drop down. I
       dont want this, the filtering needs to filter the variants."

       Picking the cheapest in-range variant fixed the PRICE ON THE CARD, but
       the select still listed every size. Under a £10 ceiling the Plagron
       Alga card read £3.95 and then offered a £113.95 option one tap away -
       which is the same bait the pick() was written to stop, just moved into
       the menu.

       ⚑ HIDDEN *AND* DISABLED, BOTH DELIBERATELY. `hidden` is what removes
       the row from the list, but Safari has historically ignored it on
       `<option>`; `disabled` is honoured everywhere and stops a keyboard user
       arrowing onto it even where hidden is ignored. Belt and braces on a
       control that takes money.

       ⚑ AND IT MUST BE REVERSIBLE. The original state is stashed once per
       option so Clear all puts every size back - without that, clearing the
       filter would leave the shopper permanently unable to buy the 5L.

       ⚑ AND THEY LIVE OUT HERE, NOT INSIDE THE PRICE GROUP'S BLOCK.
       First attempt declared them inside the `if` that builds the price
       group. Function declarations are BLOCK SCOPED, so apply() - which sits
       outside that block - could not see restoreAllOptions, and the
       `typeof === 'function'` guard I had written around the call swallowed it
       in silence. Widening the ceiling from £10 back to the maximum left six
       of eleven sizes still hidden and nothing said why.
       ⚑ A DEFENSIVE typeof GUARD AROUND YOUR OWN FUNCTION HIDES THIS EXACT
       CLASS OF BUG. The guard is gone; if it is ever undefined again it will
       throw and be visible. */
    /* ⚑ WHICH END OF THE RANGE THE CARD SHOULD SHOW, set by apply() before it
       picks. "Most expensive first" plus a ceiling is a shopper asking "what is
       the best I can get for £50" - answering it with the £3.95 size is not a
       sort, it is a shrug. Every other sort still shows the cheapest that
       qualifies. */
    var priceDearestFirst = false;

    /* ⚑ AND THE COLLAPSED SPAN HAS TO BE PUT BACK, NOT JUST THE OPTIONS.
       pick() overwrites data-bp-min and data-bp-max with the single variant it
       chose, and nothing ever restored them - so the SORT KEY stayed frozen at
       the price the previous ceiling happened to select. The cached _bpMin0 /
       _bpMax0 are the product's real span; put them back before every pass. */
    function restorePriceSpan() {
      cards.forEach(function (c) {
        if (c._bpMin0) c.setAttribute('data-bp-min', c._bpMin0);
        if (c._bpMax0) c.setAttribute('data-bp-max', c._bpMax0);
        if (c._bpArea0) c.setAttribute('data-bp-area', c._bpArea0);
      });
    }

    /* ⚑ ONE INVARIANT, ENFORCED IN ONE PLACE: THE SORT KEY IS THE PRICE ON THE
       CARD. Every earlier price-sort bug has been a version of the two drifting
       apart - pick() writing the attribute on some paths and not others, a
       size pick rewriting it behind price's back, restorePriceSpan resetting it.
       Rather than police each path, this runs after ALL picks and simply reads
       what each card is actually showing. If the card says £45.95, it sorts as
       £45.95. Nothing else can be true. */
    function syncDisplayedPrice() {
      cards.forEach(function (c) {
        var sel = c.querySelector('[data-bp-select]');
        if (!sel) return;
        var o = sel.options[sel.selectedIndex];
        var cents = o ? parseInt(o.getAttribute('data-cents'), 10) : 0;
        if (cents > 0) { c.setAttribute('data-bp-min', cents); c.setAttribute('data-bp-max', cents); }
      });
    }

    /* ⚑ EVERY PASS STARTS FROM THE SIZE THE CARD OPENED ON (or the one the
     * shopper chose), SILENTLY. Picks then change what they need to, and
     * repaintSizes() fires ONE change per card whose size actually moved.
     * Before this, each pick dispatched its own change - fine while nothing
     * was ever put back, but restoring and re-picking would repaint every
     * picked card twice on every pass, and /collections/all carries 1,546.
     *
     * ⚑ _bpPickSig IS CLEARED WITH THE RESTORE. The price pick skips a card
     * whose signature matches the current range, which was right when the
     * card kept its last pick between passes. It no longer does, so a stale
     * signature would leave it sitting on its starting size inside a range
     * that asked for another. */
    function restoreSizes() {
      return cards.map(function (c) {
        var sel = c.querySelector('[data-bp-select]');
        if (!sel) return null;
        var pre = sel.value;
        var base = c._bpUserSel !== undefined ? c._bpUserSel : c._bpSel0;
        if (base !== undefined && sel.value !== base) sel.value = base;
        delete c._bpPickSig;
        return pre;
      });
    }
    function repaintSizes(pre) {
      cards.forEach(function (c, i) {
        if (pre[i] === null || pre[i] === undefined) return;
        var sel = c.querySelector('[data-bp-select]');
        /* ⚑ NOT BUBBLING, AND THAT IS WORTH 3 SECONDS ON /collections/all.
         * Measured 23 Sep 2026 on live main with 1,550 cards: a bubbling change
         * costs 3.5ms per card, a non-bubbling one 0.007ms - 500x. Something
         * above the card, almost certainly a third-party analytics or marketing
         * script listening at document level, does real work on every bubbled
         * change. Switching ~850 cards to their dearest size took ~3s bubbling.
         *
         * Nothing needs it to bubble. hcs-brand.js repaints from a listener on
         * the select itself; the select IS the variant field the basket form
         * submits (name="id"), so Add to basket reads it directly; and no
         * engine card sits inside Dawn's <variant-selects>. A size the SHOPPER
         * picks is a real event and still bubbles as it always did - only the
         * engine's own repaints stay local, which is also the honest thing to
         * tell an analytics script: the shopper did not change those sizes. */
        if (sel && sel.value !== pre[i]) sel.dispatchEvent(new Event('change', { bubbles: false }));
      });
    }

    /* ⚑ "PRICE: MOST EXPENSIVE FIRST" SHOWS EVERY CARD ON ITS DEAREST SIZE.
     * Finbar, 23 Sep 2026: "when sorted by dearest the variant selection on the
     * search / sub cat pages with filtering shows the biggest / dearest size."
     * Only on that sort - he was explicit that it is not the default - and the
     * card goes back to its starting size the moment the sort changes, because
     * every pass starts from restoreSizes().
     *
     * It respects everything else that is active: a size the shopper chose is
     * left alone, a ticked facet (a duct size, a tent band) limits which sizes
     * qualify, and a price range hides the rest - hidden options are skipped.
     * An in-stock size is preferred; a sold-out one only if nothing else is. */
    function pickDearest() {
      cards.forEach(function (c) {
        if (c._bpUserSel !== undefined) return;
        var sel = c.querySelector('[data-bp-select]');
        if (!sel) return;
        function dearest(allowSoldOut) {
          var want = null, wantC = -1;
          Array.prototype.slice.call(sel.options).forEach(function (o) {
            if (o.hidden) return;
            var cents = parseInt(o.getAttribute('data-cents'), 10);
            if (!cents) return;
            if (!allowSoldOut && o.disabled) return;
            var ok = groups.every(function (g2) {
              var chosen = state[g2.key] || [];
              return !g2.matchOpt || !chosen.length || g2.matchOpt(o, chosen);
            });
            if (!ok) return;
            if (cents > wantC) { wantC = cents; want = o; }
          });
          return want;
        }
        var want = dearest(false) || dearest(true);
        if (want && sel.value !== want.value) sel.value = want.value;
      });
    }

    /* ⚑ "LIGHT OUTPUT" SORTS SHOW EACH LIGHT ON ITS BRIGHTEST / DIMMEST SIZE
     * (19 Oct 2026). Finbar: "I sorted by light output highest, so it should
     * automatically change to the variation which has the highest output. And
     * if I were to reverse it, it would change to the one with the lowest."
     * Same rules as pickDearest: a size the shopper chose is left alone,
     * ticked facets and the price range limit which sizes qualify, in stock
     * preferred. Reads each option's data-sp-ppf (per-size LED specs). */
    function pickByPpf(highest) {
      cards.forEach(function (c) {
        if (c._bpUserSel !== undefined) return;
        var sel = c.querySelector('[data-bp-select]');
        if (!sel || !sel.querySelector('option[data-sp-ppf]')) return;
        function best(allowSoldOut) {
          var want = null, wantV = null;
          Array.prototype.slice.call(sel.options).forEach(function (o) {
            if (o.hidden) return;
            var v = parseFloat(o.getAttribute('data-sp-ppf'));
            if (!(v > 0)) return;
            if (!allowSoldOut && o.disabled) return;
            var ok = groups.every(function (g2) {
              var chosen = state[g2.key] || [];
              return !g2.matchOpt || !chosen.length || g2.matchOpt(o, chosen);
            });
            if (!ok) return;
            if (wantV === null || (highest ? v > wantV : v < wantV)) { wantV = v; want = o; }
          });
          return want;
        }
        var want = best(false) || best(true);
        if (want && sel.value !== want.value) sel.value = want.value;
      });
    }

    function hideOutOfRange(sel, lo, hi) {
      Array.prototype.slice.call(sel.options).forEach(function (o) {
        if (o._bpWasDisabled === undefined) o._bpWasDisabled = o.disabled;
        var cents = parseInt(o.getAttribute('data-cents'), 10);
        var out = cents && (cents < lo || cents > hi);
        o.hidden = !!out;
        o.disabled = out ? true : o._bpWasDisabled;
      });
    }
    function restoreAllOptions() {
      cards.forEach(function (c) {
        var sel = c.querySelector('[data-bp-select]');
        if (!sel) return;
        Array.prototype.slice.call(sel.options).forEach(function (o) {
          o.hidden = false;
          if (o._bpWasDisabled !== undefined) o.disabled = o._bpWasDisabled;
        });
      });
    }

    /* ---- facets, all derived from the cards ------------------------------ */
    function distinct(fn) {
      var seen = {}, out = [];
      cards.forEach(function (c) {
        var vals = fn(c);
        (Array.isArray(vals) ? vals : [vals]).forEach(function (v) {
          if (!v) return;
          if (!seen[v]) { seen[v] = 1; out.push(v); }
        });
      });
      return out;
    }

    var groups = [];

    /* ⚑ ROOT-CATEGORY-ONLY PAGES (11 Sep 2026). /collections/all sets
     * data-bp-facets="rootcat" on the engine root. Finbar: "just make the
     * filtering by parent category only for /all its a rarely used page
     * anyway."
     *
     * WHY IT NEEDS ITS OWN SOURCE. The Category facet below has three, in
     * order: the band a card landed in, the page's declared sub-category, and
     * failing both the product type LEAF. On /collections/all there are no
     * bands and no declared sub-categories, so it would land on the leaf - and
     * the leaf of 1,180 products is ~180 values. That is a phone book, not a
     * filter. The ROOT of the same type string is the department a shopper
     * actually means here: Nutrients, Grow Lights, Tents, Environment.
     *
     * Everything else is dropped further down, just before the tray is built,
     * rather than by unpicking the group builders - one filter on the finished
     * list cannot break the pages that keep all their facets. */
    var ROOTCAT = root.getAttribute('data-bp-facets') === 'rootcat';
    var rootOf = function (c) {
      var t = c.getAttribute('data-bp-type') || '';
      if (t.indexOf('>') !== -1) t = t.split('>')[0];
      return t.trim();
    };
    if (ROOTCAT) {
      var rootNames = distinct(rootOf).sort();
      if (rootNames.length > 1) {
        groups.push({
          key: 'rootcat', label: 'Category', open: true,
          options: rootNames.map(function (t) { return { value: t, label: t }; }),
          test: function (c, vals) { return vals.indexOf(rootOf(c)) !== -1; }
        });
      }
    }

    /* NO AVAILABILITY FACET. Removed on Finbar's instruction, 6 Sep 2026:
     * "remove the availability in stock only entirely from filtering
     * everywhere - i dont want this". Do not reintroduce it.
     *
     * The availability SORT went the same way the next day ("no availability
     * sort anwhere", 7 Sep 2026), so nothing on these pages reads stock to
     * decide what a shopper sees or in what order. `data-bp-available` is
     * still on every card and still drives the "Out of stock" label. */

    /* Category. Two sources, in order of usefulness.
     *
     * On a banded page it is the band a card landed in - those headings were
     * written for this range and say more than a Shopify product type does.
     *
     * WHERE THERE IS ONLY ONE BAND IT FALLS BACK TO THE PRODUCT TYPE, and that
     * fallback is the whole point on /search. Desk 08's Q-08AL measured 48% of
     * site searches ending without a click - not because they come back empty
     * but because they come back enormous: `how to grow` returns 994 products,
     * `clay pebbles` 62 for one relevant. The cause is that Shopify's search
     * matches BODY TEXT and our descriptions run to 400 words, so one passing
     * mention drags 61 irrelevant products in behind the right one. The results
     * page carries only a price and a vendor facet - no category facet at all,
     * the one thing collection pages already have. This is that facet.
     *
     * Two-level types are shown as their LEAF: "Grow Lights > HPS" is filed
     * under "HPS", because the parent word is on every product on the page and
     * a facet whose every value starts with the same word filters nothing. */
    /* ⚑ THE CATCH-ALL BAND IS NOT A CATEGORY AND MUST NOT BE A FILTER VALUE.
     * Finbar: "remove full range from all category filter sorting - the full
     * range is just no sorting." Its headings - "The full range", "Also in
     * this category", "Also from this brand", "Also in this range" - are what
     * the engine prints over products NO band claimed. Offering them as a
     * facet asks the shopper to filter by "the ones we could not classify". */
    var CATCHALL = ['the full range', 'also in this category', 'also from this brand', 'also in this range'];
    function realBand(c) {
      var n = c._bpBandName || '';
      return CATCHALL.indexOf(n.toLowerCase()) === -1 ? n : '';
    }
    var bandNames = distinct(realBand);
    /* Parent collection pages (6 Sep 2026): the cards carry the product's
     * declared sub-category, which is the category a shopper means here -
     * "Base Feeds", not 180 product-type leaves. */
    var subcatOf = function (c) { return c.getAttribute('data-bp-subcat') || ''; };
    var subcats = distinct(subcatOf).sort();
    if (subcats.length > 1 && bandNames.length <= 1) {
      groups.push({
        key: 'subcat', label: 'Category', open: true,
        options: subcats.map(function (n) { return { value: n, label: n }; }),
        test: function (c, vals) { return vals.indexOf(subcatOf(c)) !== -1; }
      });
    } else if (bandNames.length > 1) {
      groups.push({
        key: 'band', label: 'Category', open: true,
        options: bandNames.map(function (n) { return { value: n, label: n }; }),
        test: function (c, vals) { return vals.indexOf(realBand(c)) !== -1; }
      });
    } else {
      var leaf = function (c) {
        var t = c.getAttribute('data-bp-type') || '';
        if (t.indexOf('>') !== -1) t = t.split('>').pop();
        return t.trim();
      };
      var types = distinct(leaf).sort();
      if (types.length > 1) {
        groups.push({
          key: 'ptype', label: 'Category', open: true,
          options: types.map(function (t) { return { value: t, label: t }; }),
          test: function (c, vals) { return vals.indexOf(leaf(c)) !== -1; }
        });
      }
    }

    /* Growing medium. Built where the cards carry two or more media, and then
     * gated like every other attribute facet - see gate() below: it shows only
     * while at least a quarter of the products in view state a medium.
     *
     * ⚑ STRICT SINCE 6 SEP 2026. A card with NO medium used to pass every
     * value - "it was not classified, which is not the same as being
     * excluded" - and that is exactly the no-op Finbar caught on Plant Health:
     * Coco and Hydro each reported 105 of 105 because 100 cards had no medium
     * and passed both. A shopper ticking Coco means "show me what is for coco";
     * a product that states no medium cannot answer that and drops out, and
     * the count beside the value is then the number of products it shows. */
    /* ⚑ `organic` IS EXCLUDED - Finbar: "Organic goes from growing medium -
     * its not a medium". The card can label a feed Organic INSTEAD of a
     * medium, which is right on the card but wrong in a facet called Growing
     * medium: soil, coco and hydro answer "what am I growing in", and organic
     * answers something else entirely. */
    function mediaOf(c) {
      return (c.getAttribute('data-bp-media') || '').split(',')
        .map(function (s) { return s.trim(); })
        .filter(function (m) { return m && m !== 'organic'; });
    }
    var media = distinct(mediaOf);
    if (media.length > 1) {
      groups.push({
        key: 'media', label: 'Growing medium', open: true,
        options: media.map(function (m) {
          return { value: m, label: m.charAt(0).toUpperCase() + m.slice(1) };
        }),
        carrier: function (c) { return mediaOf(c).length > 0; },
        test: function (c, vals) {
          var m = mediaOf(c);
          if (!m.length) return false;
          return vals.some(function (v) { return m.indexOf(v) !== -1; });
        }
      });
    }

    /* ---- Fan type: silenced or not, and what the motor is ----------------
     * Finbar, 20 Aug: a `Fan type` filter with Silenced, Non-Silenced, EC and
     * AC on the GAS page, Extractor Fans and Extraction Kits.
     *
     * ⚑ TWO AXES IN ONE GROUP, AND THAT IS DELIBERATE. A fan is BOTH Silenced
     * and EC; the two answer different questions. Ticking Silenced and EC
     * therefore means "silenced OR EC", the same as ticking two brands, which
     * is what every other facet in this tray does and what a shopper expects
     * from a list of checkboxes. Splitting them into two groups was tried and
     * reads as though the page stocks four kinds of fan.
     *
     * ⚑ AN UNCLASSIFIED CARD IS HIDDEN, NOT SHOWN. A blank means the catalogue
     * does not state the motor type, and showing an unknown fan under "EC" is
     * exactly the claim this filter exists to make. Since 6 Sep 2026 every
     * attribute facet in this tray works the same way - see gate(). The values
     * come from snippets/hcs-fan-type.liquid, which reads the product's tags
     * first and its title second.
     *
     * The group is built only where two or more distinct values exist, so it
     * cannot appear on a page with no fans on it. */
    var FAN_ORDER = ['silenced', 'non-silenced', 'ec', 'ac'];
    var FAN_LABEL = { 'silenced': 'Silenced', 'non-silenced': 'Non-Silenced', 'ec': 'EC', 'ac': 'AC' };
    function fanOf(c) {
      return (c.getAttribute('data-bp-fan') || '').split(',')
        .map(function (s) { return s.trim(); })
        .filter(function (s) { return s; });
    }
    /* ⚑ TWO CARDS MUST CARRY A FAN TYPE, NOT JUST TWO VALUES. The Fan
     * Controllers page holds ONE fan - the Mammoth S-MAX, typed as an
     * extractor fan and tagged Fan Controllers - and it alone supplies both
     * Silenced and EC, so a value count on its own put a Fan type control on a
     * page of controllers where every choice filtered to the same single
     * product. Same rule the variant facets use: one product is not a
     * category. */
    var fanCarriers = cards.filter(function (c) { return fanOf(c).length; });
    var fanVals = distinct(fanOf).filter(function (v) { return FAN_ORDER.indexOf(v) !== -1; });
    if (fanCarriers.length > 1 && fanVals.length > 1) {
      fanVals.sort(function (a, b) { return FAN_ORDER.indexOf(a) - FAN_ORDER.indexOf(b); });
      groups.push({
        key: 'fan', label: 'Fan type', open: true,
        options: fanVals.map(function (v) { return { value: v, label: FAN_LABEL[v] }; }),
        carrier: function (c) { return fanOf(c).length > 0; },
        test: function (c, vals) {
          var mine = fanOf(c);
          if (!mine.length) return false;
          return vals.some(function (v) { return mine.indexOf(v) !== -1; });
        }
      });
    }

    /* ---- VARIANT-LEVEL FACETS, AND EACH ONE IS SCOPED TO A KIND OF PRODUCT --
     *
     * ⚑ THE FIRST VERSION READ SIZES OUT OF ANY VARIANT LABEL AND CALLED THEM
     * "Duct size". That put a duct filter on ROCKWOOL, whose variants are 3in
     * and 4in propagation CUBES - the same numbers, a completely different
     * thing. Finbar: "Rockwool section has duct size as sorting this should be
     * cube size" and "make sure duct size hasnt been wrongly added to sections
     * that dont have a duct."
     *
     * ⚑ SO A VARIANT FACET NOW HAS TO CLAIM A KIND OF PRODUCT BEFORE IT CAN
     * APPEAR. `scope` is tested against the page's product types, and a facet
     * whose scope no page type matches is never built. Reading a number out of
     * a label tells you the number, never what it measures - only the product
     * type can say that.
     *
     * Each facet PICKS a variant as well as filtering, so choosing 150mm both
     * narrows the page and preselects the 150mm option on every card that has
     * one - see the pick() note below.
     */
    function typesOf() {
      var t = [];
      cards.forEach(function (c) {
        var v = (c.getAttribute('data-bp-type') || '').toLowerCase();
        if (v && t.indexOf(v) === -1) t.push(v);
      });
      return t.join(' | ');
    }
    var pageTypes = typesOf();

    function optLabels(c) {
      var sel = c.querySelector('[data-bp-select]');
      if (!sel) return [];
      return Array.prototype.slice.call(sel.options).map(function (o) {
        return { el: o, text: (o.textContent || '').toLowerCase() };
      });
    }

    /* ⚑ MILLIMETRES ARE THE CANONICAL FORM AND THE INCHES ARE SHOWN IN
     * BRACKETS - Finbar: 'add the inch size in brackets ... like this:
     * "150mm (6\")"'. The trade quotes both and a shopper knows one or the
     * other, so the value is one thing and the label says both. */
    /* ⚑ A DUCT SIZE IS ONE OF SEVEN NUMBERS. IT IS A WHITELIST, NOT A PATTERN.
     * Finbar: "on carbon filters you've taken some the lengths as the duct size
     * ... ducts are always 100, 125, 150, 200, 250, 315 and very rarely 355."
     *
     * A carbon filter's variant reads `10" x 660mm (3800m3/h)` or
     * `12" (315mm) / 1000mm` - the millimetres are the BODY LENGTH as often as
     * the collar. Matching "any three digits followed by mm" turned lengths
     * into duct sizes and offered 400mm, 600mm, 660mm and 750mm ducts that do
     * not exist. It also produced `000mm`, which is the last three digits of
     * 1000mm.
     *
     * ⚑ THE INCH IS TESTED FIRST, AND THAT IS THE REAL FIX. On these labels the
     * inch is always the duct and the millimetres are frequently something
     * else, so reading the inch first is right far more often than reading the
     * number nearest `mm`. The millimetre branch is the fallback for labels
     * that give no inch at all, and it is bounded by the same seven values.
     *
     * ⚑ 300mm AND 160mm ARE GONE. Neither is a duct size, and 300 was being
     * labelled 12" - the same inch as 315mm, so the list offered two twelves.
     *
     * The leading `(?:^|[^\d])` is what stops `1000mm` yielding `000`. */
    var DUCT_IN = { '100': '4', '125': '5', '150': '6', '200': '8', '250': '10', '315': '12', '355': '14' };
    var DUCT_BY_IN = { '4': '100', '5': '125', '6': '150', '8': '200', '10': '250', '12': '315', '14': '355' };
    function ductOf(t) {
      var inch = /(?:^|[^\d])(\d{1,2})\s*(?:"|”|inch\b|in\b)/.exec(t);
      if (inch && DUCT_BY_IN[inch[1]]) return DUCT_BY_IN[inch[1]] + 'mm';
      var mm = /(?:^|[^\d])(\d{3})\s*mm/.exec(t);
      if (mm && DUCT_IN[mm[1]]) return mm[1] + 'mm';
      return null;
    }
    /* A clip fan is bought on blade diameter, and the range writes it both
     * ways - `E6 6" Oscillating` and `S6 (150mm)`. Inches are the trade unit
     * here, so millimetres are converted rather than shown alongside, or the
     * same fan appears twice under two spellings of one size. */
    var BLADE_MM = { '150': '6', '200': '8', '230': '9', '250': '10', '300': '12', '400': '16', '450': '18', '500': '20' };
    function bladeOf(t) {
      var inch = /(?:^|[^\d])(\d{1,2})\s*(?:"|”|inch\b|in\b)/.exec(t);
      if (inch) return inch[1] + '"';
      var mm = /(?:^|[^\d])(\d{3})\s*mm/.exec(t);
      if (mm && BLADE_MM[mm[1]]) return BLADE_MM[mm[1]] + '"';
      return null;
    }
    function cubeOf(t) {
      var m = /(\d(?:\.\d)?)\s*(?:"|inch|in\b|”)/.exec(t);
      return m ? m[1] + '"' : null;
    }
    function ampOf(t) {
      var m = /(\d{1,2}(?:\.\d)?)\s*(?:a\b|amp)/.exec(t);
      return m ? m[1] + 'A' : null;
    }
    function bottleMl(v) {
      var n = parseFloat(v) || 0;
      return /ml$/i.test(v) ? n : n * 1000;
    }
    function bottleOf(t) {
      var l = /(\d+(?:\.\d+)?)\s*(?:l\b|ltr|litre)/.exec(t);
      if (l) return l[1] + 'L';
      var ml = /(\d{2,4})\s*ml\b/.exec(t);
      if (ml) return ml[1] + 'ml';
      var kg = /(\d+(?:\.\d+)?)\s*kg\b/.exec(t);
      if (kg) return kg[1] + 'kg';
      return null;
    }

    /* ---- TENT SIZE: FOOTPRINT AND HEIGHT, READ OFF THE TENT ITSELF --------
     *
     * ⚑ THE GROW TENTS PAGE WAS OFFERING "FIXTURE SIZE" - a grow-light facet.
     * The spec card writes data-bp-dim from any `Size:` / `Dimensions:` row,
     * a tent's spec block has one, and the fixture facet was built from that
     * attribute with NO product-type scope at all. Same fault as the rockwool
     * duct filter: a number read out of a label says nothing about what it
     * measures. Both spec facets are now scoped to lighting types below, and
     * tents get their own facet here.
     *
     * A shopper picks a tent on FLOOR SPACE first - 60x60, 120x120, 240x120 -
     * and on HEIGHT second (an attic, a bench-top propagator). So there are
     * two facets over one parse. The footprint is read from each card's own
     * variant labels first (`844 - 1.2 x 1.2 x 2m` on a multi-size tent, so
     * choosing a size also picks that variant, exactly as duct size does), and
     * from the TITLE only when no option carries a size - `BAY6 2m x 3m x 2m`,
     * `BudBox Pro Tent Kit 120x240x200cm`, `RQ120 - 120 x 120 x 180`.
     *
     * ⚑ ONE UNIT, AND THE UNIT COMES FROM THE RUN, NOT THE STRING. `0.75m x
     * 0.75 x 1.3m` has no unit on its middle number; `120 x 120 x 200` has
     * none anywhere. Any `cm` in the run means centimetres, else any `mm`,
     * else any `m`; a bare run is metres under 20 and centimetres over. Then
     * every value is centimetres. `2.4m x 1.2m` and `1.2m x 2.4m` are the SAME
     * TENT turned round, so the footprint is stored short side first.
     *
     * ⚑ REJECT BY DEFAULT. The first number must not be glued to a letter
     * (`RQ120`), nothing may follow the run (`2x600W` is two lights, not a
     * 2m by 600m room), and a footprint outside 30cm-10m or a height outside
     * 50cm-4m is discarded. No size is better than a wrong size: an unread
     * tent simply does not appear under the facet, and it is still on the
     * page. Same doctrine as snippets/hcs-tent-dims.liquid, which does the
     * server-side half of this for the sort. */
    function tentDims(s) {
      s = (s || '').toLowerCase().replace(/×/g, 'x').replace(/cms\b/g, 'cm');
      var re = /(?:^|[^a-z0-9.])(\d+(?:\.\d+)?)\s*(cm|mm|m)?\s*x\s*(\d+(?:\.\d+)?)\s*(cm|mm|m)?(?:\s*x\s*(\d+(?:\.\d+)?)\s*(cm|mm|m)?)?(?![a-z0-9])/;
      var m = re.exec(s);
      if (!m) return null;
      var units = [m[2], m[4], m[6]].filter(Boolean);
      var scale;
      if (units.indexOf('cm') !== -1) scale = 1;
      else if (units.indexOf('mm') !== -1) scale = 0.1;
      else if (units.indexOf('m') !== -1) scale = 100;
      else scale = (Math.max(parseFloat(m[1]), parseFloat(m[3])) < 20) ? 100 : 1;
      var w = Math.round(parseFloat(m[1]) * scale);
      var d = Math.round(parseFloat(m[3]) * scale);
      var h = m[5] ? Math.round(parseFloat(m[5]) * scale) : 0;
      if (!(w >= 30 && w <= 1000 && d >= 30 && d <= 1000)) return null;
      if (h && !(h >= 50 && h <= 400)) h = 0;
      return { w: Math.min(w, d), d: Math.max(w, d), h: h };
    }
    /* ⚑ BANDS, NOT ONE ROW PER FOOTPRINT. Finbar, 2 Sep: "there should be
     * more ranges and less options." With every tent on the page the
     * footprint list ran to twenty rows - 40×60, 60×60, 60×90, 75×75 ... - and
     * a list that long is a catalogue, not a filter. Five floor-area bands
     * are how the trade sizes a room: a Small up to a square metre, a Medium
     * to two, a Large to four, an Extra large to eight, and anything bigger
     * is a Room. The upper bound is INCLUSIVE so 100×100 (exactly 1 m²) is
     * Small and 200×200 (exactly 4 m²) is Large, which is what anyone reading
     * "up to" would expect. The exact footprint is still printed on every
     * card, so nothing is lost - the shopper narrows to a band, then reads.
     * There is no height facet - one filter for size, on Finbar's word. */
    /* ⚑ ONE LINE EACH (19 Oct 2026). Finbar: "Tent size is okay, but it
     * splits over two rows and just looks computer made and weird." The old
     * "Small \u2014 up to 1 m\u00b2" labels ran 125-160px in a 143px column,
     * so four of five wrapped. The name and the range now sit on one line,
     * the range muted: everything after " \u00b7 " is drawn as a quieter
     * second part by the option renderer (search hcs-bp__fopt-sub). */
    var TENT_BANDS = [
      ['t1', 1.0, 'Small \u00b7 up to 1m\u00b2'],
      ['t2', 2.0, 'Medium \u00b7 1\u20132m\u00b2'],
      ['t3', 4.0, 'Large \u00b7 2\u20134m\u00b2'],
      ['t4', 8.0, 'Extra large \u00b7 4\u20138m\u00b2'],
      ['t5', 1e9, 'Room \u00b7 over 8m\u00b2']
    ];
    function bandOf(bands, v) {
      for (var i = 0; i < bands.length; i++) { if (v <= bands[i][1]) return bands[i][0]; }
      return null;
    }
    function bandLabel(bands) {
      var m = {}; bands.forEach(function (b) { m[b[0]] = b[2]; });
      return function (v) { return m[v] || v; };
    }
    function bandOrder(a, b) { return parseInt(a.slice(1), 10) - parseInt(b.slice(1), 10); }
    function tentAreaOf(t) { var r = tentDims(t); return r ? r.w * r.d : 0; }
    function tentFootOf(t) { var a = tentAreaOf(t); return a ? bandOf(TENT_BANDS, a / 10000) : null; }
    function fromTitle(parse) {
      return function (c) { return parse(c.getAttribute('data-bp-title') || ''); };
    }
    /* ⚑ A TENT FACET CLAIMS ONLY TENTS. `Tents > BAY6`, `Tents > Grow Tents`,
     * `Tents > Propagation Tents`, `Tents > Tent Kits` - a kit is bought on
     * the tent's footprint too. Anything on a tent page that is not typed as
     * a tent - a pole set, a tray, the kit's light listed alone - is outside
     * the scope and never contributes a size. */
    var TENT_SCOPE = /^tents?\s*>|\btent\b/;
    var TENT_NOT = /accessor|pole|tray|sheet|light|lamp|fan|filter|duct|heater|mat\b/;

    var VARIANT_FACETS = [
      { key: 'duct', label: 'Duct size', parse: ductOf, sort: 'num',
        show: function (v) { var i = DUCT_IN[parseInt(v, 10)]; return i ? v + ' (' + i + '")' : v; },
        /* ⚑ `circulation` IS DELIBERATELY ABSENT. A clip or floor fan has NO
         * DUCT - its variants are BLADE diameters, `S6 (150mm)` and
         * `E6 6" Oscillating`. The page was offering "Duct size: 150mm, 315mm"
         * for fans that do not connect to ducting at all. Same fault as the
         * carbon-filter lengths, one page along. Blade size gets its own facet
         * below, because it IS what a shopper picks a clip fan on. */
        scope: /ducting|extractor|carbon filter|silencer|ventilation|environment/,
        /* ⚑ A POSITIVE SCOPE WAS NOT ENOUGH. Removing `circulation` from the
         * list above changed nothing, because a clip fan is typed
         * `Environment > Circulation Fans` - it matched on `environment`, the
         * broadest word in the scope. Environment covers ducted extraction AND
         * clip fans AND dehumidifiers AND CO2, so the only reliable statement
         * is which of those do NOT have a duct. */
        not: /circulation|humidity|dehumidif|controller|co2|temperature|heating|odour/ },
      /* ⚑ THE TITLE IS READ TOO (6 Sep 2026). Most clip and pedestal fans are
       * one product with the size in the NAME - `16" Wall Fan`, `Vortex 18in
       * Windpro`, `Growth Technology 6" (150mm) Clip On Fan` - so reading
       * options alone covered 3 of the 13 fans on the Circulation Fans page
       * and the facet failed its own coverage test. Options still win where
       * they carry a size, because an option is something the facet can pick. */
      { key: 'blade', label: 'Fan size', parse: bladeOf, sort: 'num',
        fallback: fromTitle(bladeOf), scope: /circulation/ },
      { key: 'cube', label: 'Cube size', parse: cubeOf, sort: 'num',
        scope: /rockwool|propagation > medium|growing medium|rooting|propagator/ },
      /* ⚑ THIS IS A CONTROLLER CAPACITY FILTER AND THE LABEL NOW SAYS SO.
       * Finbar, 20 Aug: "Rated Amps is mislabelled and mis-scoped ... selecting
       * it must REMOVE fans from the results."
       *
       * It did the opposite: the shared test let a card with no value through,
       * so on Fan Controllers every amp value reported twenty of twenty-one
       * products - the nineteen cards with no rating passed every value. The
       * count read like a facet and behaved like a no-op. This facet was made
       * strict on 20 Aug; ⚑ ON 6 SEP 2026 EVERY FACET IN THE LIST BECAME
       * STRICT, because the same no-op had spread to Duct size, Cube size,
       * Size and Growing medium on every page where they covered a minority -
       * Plant Health offered seven duct sizes each reporting 104 or 105 of
       * 105 products. See the test() below and gate(). */
      { key: 'amp', label: 'Rated Amps (Controllers)', parse: ampOf, sort: 'num',
        scope: /controller|electrical|timers|contactor/ },
      /* ⚑ ORDERED BY VOLUME, NOT BY THE LEADING NUMBER. `parseFloat` put the
       * list as 1L, 2kg, 3L ... 20L, 25ml, 50ml, 500ml - every millilitre size
       * after every litre. bottleMl() reads the unit, so 25ml leads and 20L
       * closes; a kilogram is ranked with a litre, which is where a shopper
       * expects a 2kg tub of powder to sit. */
      { key: 'bottle', label: 'Size', parse: bottleOf, sort: 'num',
        order: function (a, b) { return bottleMl(a) - bottleMl(b); },
        scope: /nutrient|feed|booster|stimulator|enzyme|ph & nutrient|ph &amp; nutrient|plant health/ },
      /* A footprint is something a tent STATES; a product that states none - a
       * mushroom lab sold as XS/S/M, a light on a kit page, a pole set - cannot
       * satisfy "120 × 240 cm" and drops out when one is ticked. */
      { key: 'tent', label: 'Tent size', parse: tentFootOf, order: bandOrder, show: bandLabel(TENT_BANDS),
        fallback: fromTitle(tentFootOf), scope: TENT_SCOPE, not: TENT_NOT, area: true }
      /* ⚑ NO HEIGHT FACET. Finbar, 2 Sep: "we just need one filter for size."
       * The height is still parsed (tentDims reads it) and still printed on
       * the card; it is simply not offered as a filter. */
    ];

    /* ⚑ THE SIZE SORT IS SEEDED HERE, NOT LEFT TO LIQUID. `data-bp-area` is
     * written by the spec card from hcs-tent-dims on a `range` page - which
     * covers a tent whose size is in its TITLE, on the four range pages. It
     * does not cover a tent whose sizes live in its VARIANTS (the CLOUDLAB
     * has nine), a tent on a `generic` page (the kit pages render grid cards
     * with no spec block), or a title Liquid could not read. Finbar, 2 Sep:
     * "add a sort by size biggest to smallest or smallest to biggest here."
     * So every in-scope tent card gets an area from the same parse the facet
     * uses - smallest variant when there are several, so "smallest first"
     * leads with the smallest thing for sale - and the sort option appears
     * on any page holding two or more sized tents. Cached as _bpArea0 and
     * put back before every pass, exactly like the price span, so a pick
     * can move it and Clear all puts it back. */
    cards.forEach(function (c) {
      var t = (c.getAttribute('data-bp-type') || '').toLowerCase();
      if (!TENT_SCOPE.test(t) || TENT_NOT.test(t)) return;
      var areas = [];
      optLabels(c).forEach(function (o) { var a = tentAreaOf(o.text); if (a) areas.push(a); });
      if (!areas.length) { var a0 = tentAreaOf(c.getAttribute('data-bp-title') || ''); if (a0) areas.push(a0); }
      if (areas.length) c.setAttribute('data-bp-area', Math.min.apply(null, areas));
    });
    cards.forEach(function (c) { c._bpArea0 = c.getAttribute('data-bp-area'); });

    VARIANT_FACETS.forEach(function (f) {
      if (!f.scope.test(pageTypes)) return;
      /* ⚑ THE SCOPE IS TESTED PER CARD, NOT PER PAGE, AND THAT IS THE FIX.
       * Testing the page's combined types meant ONE stray product pulled in a
       * whole facet: the Meters page carries a couple of environment
       * controllers, so it offered "Duct size"; the Canna page carries Canna
       * Coco, typed Growing Medium, so it offered "Cube size" on a nutrient
       * brand. Both are exactly what Finbar meant by "make sure duct size
       * hasnt been wrongly added to sections that dont have a duct".
       *
       * Sizes are now read ONLY from cards whose own product type matches, so
       * a facet describes the products it filters. A page needs at least two
       * such cards before the control is built at all - one product does not
       * make a category - and gate() then shows it only while those cards are
       * at least a quarter of what is in view. */
      function inScope(c) {
        var t = (c.getAttribute('data-bp-type') || '').toLowerCase();
        if (f.not && f.not.test(t)) return false;
        return f.scope.test(t);
      }
      function sizesOf(c) {
        if (!inScope(c)) return [];
        var out = [];
        optLabels(c).forEach(function (o) {
          var d = f.parse(o.text);
          if (d && out.indexOf(d) === -1) out.push(d);
        });
        /* ⚑ THE TITLE IS THE FALLBACK, NEVER THE FIRST CHOICE. A tent with one
         * size has no select, or a select of colours or ballast types, so its
         * size lives in the title alone. Options win where they carry a size,
         * because an option is something the facet can PICK. */
        if (!out.length && f.fallback) {
          var t = f.fallback(c);
          if (t) out.push(t);
        }
        return out;
      }
      var carriers = cards.filter(function (c) { return sizesOf(c).length; });
      if (carriers.length < 2) return;
      var vals = distinct(sizesOf);
      if (vals.length < 2) return;
      vals.sort(f.order || function (a, b) { return parseFloat(a) - parseFloat(b); });
      groups.push({
        key: f.key, label: f.label, open: true,
        options: vals.map(function (v) { return { value: v, label: f.show ? f.show(v) : v }; }),
        carrier: function (c) { return sizesOf(c).length > 0; },
        /* ⚑ STRICT: a card that states no size for this facet never passes a
         * ticked value. Ticking 150mm means "show me what comes in 150mm", and
         * a product with no duct cannot answer that. The count beside a value
         * is therefore the number of products it will show. */
        test: function (c, chosen) {
          var mine = sizesOf(c);
          if (!mine.length) return false;
          return mine.some(function (m) { return chosen.indexOf(m) !== -1; });
        },
        /* Does ONE option satisfy this facet? The price pick below uses it so
         * that narrowing by price cannot silently change the duct size a
         * shopper has already asked for. */
        matchOpt: function (o, chosen) {
          var d = f.parse((o.textContent || '').toLowerCase());
          return !!d && chosen.indexOf(d) !== -1;
        },
        /* ⚑ CHOOSING A SIZE PRESELECTS THAT VARIANT AND REWRITES THE PRICE THE
         * SORT READS, so "cheapest first" on 150mm means cheapest 150mm rather
         * than cheapest anything. The pick runs before the sort - see apply(). */
        pick: function (c, chosen) {
          var sel = c.querySelector('[data-bp-select]');
          if (!sel) return;
          var want = null;
          optLabels(c).forEach(function (o) {
            if (want) return;
            var d = f.parse(o.text);
            if (d && chosen.indexOf(d) !== -1 && !o.el.disabled) want = o.el;
          });
          if (!want) return;
          /* ⚑ THE AREA IS WRITTEN WHETHER OR NOT THE SELECT CHANGES - the same
           * fault the price sort had on 24 Aug. restorePriceSpan() puts the
           * product's smallest area back before every pass, so on the second
           * pass (the shopper changes the sort) the select already shows the
           * Large variant, the early return below fires, and a write placed
           * after it never runs: the nine-size tent sorted on its 60×60 while
           * displaying 240×120. The price side is safe because
           * syncDisplayedPrice() re-reads the select after every pick; the
           * area has no such sweep, so it is written here, before the return. */
          if (f.area) {
            var ar = tentAreaOf((want.textContent || '').toLowerCase());
            if (ar) c.setAttribute('data-bp-area', ar);
          }
          if (sel.value === want.value) return;
          sel.value = want.value;   /* repainted once, by repaintSizes() in apply() */
          var cents = parseInt(want.getAttribute('data-cents'), 10);
          if (cents) { c.setAttribute('data-bp-min', cents); c.setAttribute('data-bp-max', cents); }
        }
      });
    });

    /* ⚑ THE VENDOR FIELD IS DIRTY AND THE FACET MUST FOLD IT.
     * Finbar saw VIVOSUN, VivoSun and Vivosun as three separate brands with
     * three separate counts. The desk has recorded the vendor field as dirty
     * since the brand-page build - CANNA/Canna, OptiClimate/Opticlimate - and
     * `hcs-brand-url.liquid` already normalises it by downcasing for exactly
     * this reason. The facet groups on the LOWERCASED name and displays the
     * spelling that appears most often, so one brand is one row with one count.
     *
     * ⚑ AND A ONE-BRAND PAGE GETS NO BRAND FACET. On /collections/vivosun
     * every product is Vivosun, so the control could only ever filter to
     * everything or nothing. That falls out of the `> 1` test once the casing
     * is folded - before folding, a brand page showed three brands. */
    var vendorKeys = [], vendorSeen = {};
    cards.forEach(function (c) {
      var raw = (c.getAttribute('data-bp-vendor') || '').trim();
      if (!raw) return;
      var k = raw.toLowerCase();
      if (!vendorSeen[k]) { vendorSeen[k] = {}; vendorKeys.push(k); }
      vendorSeen[k][raw] = (vendorSeen[k][raw] || 0) + 1;
    });
    if (vendorKeys.length > 1) {
      vendorKeys.sort();
      groups.push({
        key: 'vendor', label: 'Brand', open: vendorKeys.length <= 8,
        options: vendorKeys.map(function (k) {
          var forms = vendorSeen[k], best = null, n = -1;
          Object.keys(forms).forEach(function (f) { if (forms[f] > n) { n = forms[f]; best = f; } });
          return { value: k, label: best };
        }),
        test: function (c, vals) {
          return vals.indexOf((c.getAttribute('data-bp-vendor') || '').trim().toLowerCase()) !== -1;
        }
      });
    }

    /* ---- Price: a range, not five boxes ---------------------------------
     * Finbar: "Make price sorting a slider with min and max entry everywhere."
     *
     * ⚑ THE BANDS WERE ALWAYS A COMPROMISE. "Under £25" held 131 products on
     * base feeds and "£50 to £100" held one - a facet where one value is most
     * of the page and another is a single product is not helping anyone choose.
     * A range takes the actual floor and ceiling of what is on the page, so it
     * fits every page without a hard-coded bucket list.
     *
     * ⚑ THE STATE IS ONE ENTRY, `['min-max']`, so the existing count, clear and
     * badge logic all keep working untouched. It is only rendered differently.
     */
    /* ⚑ THE CEILING IS THE DEAREST VARIANT ON THE PAGE, NOT THE DEAREST
     * STARTING PRICE. It used to be the largest data-bp-min, which on a page
     * of multi-size fans is nowhere near the top of what is actually for sale
     * - the range simply could not reach the 14" fans. It matters now that the
     * test below is an overlap rather than a test on the starting price. */
    var priceLo = [], priceHi = [];
    cards.forEach(function (c) {
      if (c._bpMin0 > 0) { priceLo.push(c._bpMin0); priceHi.push(c._bpMax0 || c._bpMin0); }
    });
    if (priceLo.length > 1) {
      var pLo = Math.floor(Math.min.apply(null, priceLo) / 100);
      var pHi = Math.ceil(Math.max.apply(null, priceHi) / 100);
      if (pHi > pLo) {
            /* ---- light output and fixture size, on lighting pages only ----------
     *
     * Finbar, 21 Aug: "add ppf filtering to all relevant grow light pages ...
     * same with size / dimensions of actual light, not coverage."
     *
     * ⚑ BANDS, NOT ONE TICKBOX PER VALUE. PPF is a continuous figure - 15.62
     * on a propagation strip, 3193 on a 1030W PRO - so a facet listing every
     * distinct value would be ninety single-product rows. The bands are the
     * ones a grower actually shops in: a tent size implies a PPF range.
     *
     * ⚑ THE FACET ONLY EXISTS WHERE THE PAGE CAN ANSWER IT. Two carriers
     * minimum, same rule as every other spec facet - one stray fixture on a
     * ballast page must not raise a "Light output" filter that then filters
     * to a single product.
     *
     * ⚑ A CARD WITH NO FIGURE IS NOT PLACED IN A BAND. It has no
     * data-bp-ppf at all, so it cannot match any band and simply drops out
     * when one is ticked. That is the honest behaviour: we do not know its
     * output, so we cannot claim it is over 1000. The research sheet lists
     * every light we could not find a figure for.
     */
    [
      { key: 'ppf', attr: 'data-bp-ppf', label: 'Light output (PPF)',
        bands: [[0, 200, 'Under 200 \u00b5mol/s'], [200, 700, '200 \u2013 700 \u00b5mol/s'],
                [700, 1200, '700 \u2013 1200 \u00b5mol/s'], [1200, 2000, '1200 \u2013 2000 \u00b5mol/s'],
                [2000, 1e9, 'Over 2000 \u00b5mol/s']] },
      /* ⚑ WIDTH, NOT AREA (19 Oct 2026). Finbar: "the fixture size needs to
       * be the width of the light on the m2 that's not a measure people use."
       * data-bp-dim is now the fixture's width in cm (hcs-brand-unit.liquid).
       * The edges are the tent widths a light is bought for - 60, 80, 100,
       * 120 - and each upper bound is inclusive (values are whole cm, so
       * `< 61` is "up to 60"). Measured 19 Oct over the LED, propagation,
       * Omega and Maxibright pages: widths cluster at 50-66cm and 105-120cm. */
      { key: 'fixw', attr: 'data-bp-dim', label: 'Fixture width',
        bands: [[0, 61, 'Up to 60cm'], [61, 81, '60\u201380cm'], [81, 101, '80\u2013100cm'],
                [101, 121, '100\u2013120cm'], [121, 1e9, 'Over 120cm']] }
    ].forEach(function (spec) {
      /* ⚑ SCOPED PER CARD TO LIGHTING TYPES, AND THAT IS THE 2 SEPTEMBER FIX.
       * data-bp-dim is written by the spec card from ANY `Size:` row, and a
       * tent's spec block has one - so the Grow Tents page grew a "Fixture
       * size" facet built from tent footprints. A product type is the only
       * thing that says what a number measures; a card whose type is not a
       * light contributes nothing here, and two such cards are needed before
       * the control appears. Same rule as every variant facet above. */
      var LIGHT_SCOPE = /grow lights|propagation > lights|led|lamp|hps|cdm|reflector|fixture|ballast|bulb/;
      var carriers = cards.filter(function (c) {
        var t = (c.getAttribute('data-bp-type') || '').toLowerCase();
        if (!LIGHT_SCOPE.test(t) || TENT_SCOPE.test(t)) return false;
        return parseFloat(c.getAttribute(spec.attr)) > 0;
      });
      if (carriers.length < 2) return;
      var opts = spec.bands.map(function (b) {
        var n = carriers.filter(function (c) {
          var v = parseFloat(c.getAttribute(spec.attr));
          return v >= b[0] && v < b[1];
        }).length;
        return n ? { value: b[0] + '-' + b[1], label: b[2] } : null;
      }).filter(Boolean);
      if (opts.length < 2) return;
      groups.push({
        key: spec.key, label: spec.label, open: opts.length < 5, options: opts,
        carrier: function (c) { return carriers.indexOf(c) !== -1; },
        test: function (c, vals) {
          var v = parseFloat(c.getAttribute(spec.attr));
          if (!(v > 0)) return false;
          return vals.some(function (r) {
            var p = r.split('-');
            return v >= parseFloat(p[0]) && v < parseFloat(p[1]);
          });
        }
      });
    });

    /* ---- water flow, on pump pages (22 Oct 2026) ------------------------
     *
     * Finbar: "For irrigation pumps, water flow is essential as a filter."
     *
     * ⚑ BANDED LIKE PPF, BUT READ PER SIZE LIKE DUCT SIZE. One pump listing
     * runs 1,000 to 8,000 L/h across its sizes, so the card's current size
     * alone would hide the listing from every band but one. Each size's flow
     * rides on its option (data-sp-flow, from the specs.flow_lph variant
     * metafield); a one-size pump carries it on the card (data-bp-flow).
     * A band matches when ANY size falls in it, and picking a band selects
     * the first size inside it - so the card, its price and the sort all
     * describe a pump that answers the filter.
     *
     * ⚑ SCOPED PER CARD TO `Irrigation Pumps`. An air pump's L/min and a
     * doser's working range are not this figure; a card with no flow drops
     * out when a band is ticked, the same strict rule as every facet here. */
    /* 23 Oct 2026: the same mechanism for AIR OUTPUT on air pumps and
     * AIRFLOW on carbon filters - Finbar: "Do the air pumps and the carbon
     * filters after". One entry per family: the card/option attribute it
     * reads (data-bp-<attr> / data-sp-<attr>, written by hcs-brand-unit from
     * the family's specs.* metafield), the product types it may read it from,
     * and bands with inclusive upper bounds. */
    var SPEC_BANDS = [
      { key: 'flow', label: 'Water flow', attr: 'flow', scope: /irrigation pump/,
        bands: [[0, 1001, 'Up to 1,000 L/h'], [1001, 3001, '1,000–3,000 L/h'],
                [3001, 6001, '3,000–6,000 L/h'], [6001, 10001, '6,000–10,000 L/h'],
                [10001, 1e9, 'Over 10,000 L/h']] },
      { key: 'aout', label: 'Air output', attr: 'aout', scope: /air pump/,
        bands: [[0, 5.01, 'Up to 5 L/min'], [5.01, 20.01, '5–20 L/min'], [20.01, 50.01, '20–50 L/min'],
                [50.01, 100.01, '50–100 L/min'], [100.01, 1e9, 'Over 100 L/min']] },
      { key: 'cair', label: 'Airflow', attr: 'air', scope: /carbon filter/,
        bands: [[0, 501, 'Up to 500 m³/h'], [501, 1001, '500–1,000 m³/h'], [1001, 2001, '1,000–2,000 m³/h'],
                [2001, 3501, '2,000–3,500 m³/h'], [3501, 1e9, 'Over 3,500 m³/h']] }
    ];
    SPEC_BANDS.forEach(function (sb) {
      function valOf(o) { var f = parseFloat(o.getAttribute('data-sp-' + sb.attr)); return f > 0 ? f : 0; }
      function valsOf(c) {
        if (!sb.scope.test((c.getAttribute('data-bp-type') || '').toLowerCase())) return [];
        var out = [];
        optLabels(c).forEach(function (o) { var f = valOf(o.el); if (f) out.push(f); });
        if (!out.length) { var f0 = parseFloat(c.getAttribute('data-bp-' + sb.attr)); if (f0 > 0) out.push(f0); }
        return out;
      }
      function inBand(f, vals) {
        return vals.some(function (r) { var p = r.split('-'); return f >= parseFloat(p[0]) && f < parseFloat(p[1]); });
      }
      var carriers = cards.filter(function (c) { return valsOf(c).length > 0; });
      if (carriers.length < 2) return;
      var opts = sb.bands.map(function (b) {
        var n = carriers.filter(function (c) {
          return valsOf(c).some(function (f) { return f >= b[0] && f < b[1]; });
        }).length;
        return n ? { value: b[0] + '-' + b[1], label: b[2] } : null;
      }).filter(Boolean);
      if (opts.length < 2) return;
      groups.push({
        key: sb.key, label: sb.label, open: true, options: opts,
        carrier: function (c) { return carriers.indexOf(c) !== -1; },
        test: function (c, vals) { return valsOf(c).some(function (f) { return inBand(f, vals); }); },
        matchOpt: function (o, vals) { var f = valOf(o); return !!f && inBand(f, vals); },
        pick: function (c, vals) {
          var sel = c.querySelector('[data-bp-select]');
          if (!sel) return;
          var want = null;
          optLabels(c).forEach(function (o) {
            if (want) return;
            var f = valOf(o.el);
            if (f && inBand(f, vals) && !o.el.disabled) want = o.el;
          });
          if (!want || sel.value === want.value) return;
          sel.value = want.value;   /* repainted once, by repaintSizes() in apply() */
          var cents = parseInt(want.getAttribute('data-cents'), 10);
          if (cents) { c.setAttribute('data-bp-min', cents); c.setAttribute('data-bp-max', cents); }
        }
      });
    });

groups.push({
          key: 'price', label: 'Price', open: true, range: true, lo: pLo, hi: pHi,
          options: [],
          /* ⚑ OVERLAP, NOT "IS THE STARTING PRICE IN RANGE". A fan whose sizes
           * run £248 to £479 IS buyable for £300-£350 and belongs in that
           * result; the old test read only its cheapest variant, so raising
           * the minimum threw out every product whose small size was cheap.
           * A max-only filter behaves exactly as it did - the minimum sits on
           * the page floor, so `_bpMax0 >= lo` is always true. */
          test: function (c, vals) {
            if (!vals.length) return true;
            var parts = String(vals[0]).split('-');
            var lo = parseFloat(parts[0]) * 100, hi = parseFloat(parts[1]) * 100;
            if (c._bpPrices) {
              return c._bpPrices.some(function (n) { return n >= lo && n <= hi; });
            }
            return c._bpMax0 >= lo && c._bpMin0 <= hi;
          },
          /* ⚑ THE CARD MUST SHOW A PRICE THAT PASSES THE FILTER. Finbar, 20
           * Aug: a maximum of £142 correctly dropped the products with nothing
           * under £142, "but the products that REMAINED still displayed their
           * MOST EXPENSIVE variant's price ... that reads as a bait price."
           *
           * A card shows `selected_or_first_available_variant`, which is the
           * first variant in the product's own order and NOT necessarily the
           * cheapest - Phresh EC Silenced HyperFans lists 6" at £216.99 ahead
           * of 8" at £187.95, so under a £200 ceiling it advertised £216.99.
           *
           * So the cheapest IN-RANGE variant is selected, exactly the way the
           * duct-size facet preselects a size. Selecting it fires `change`,
           * which is what repaints the price, the image and the button through
           * hcs-brand.js, and rewrites data-bp-min so "cheapest first" means
           * cheapest within the range the shopper asked for.
           *
           * ⚑ IT RUNS LAST AND STILL RESPECTS THE OTHER FACETS. Price is the
           * final group pushed, so its pick runs after Duct size has chosen a
           * size - and it will not undo that choice unless nothing in the
           * chosen size is affordable, in which case the price wins, because
           * the price is the promise being made on the card. */
          pick: function (c, vals) {
            var sel = c.querySelector('[data-bp-select]');
            if (!sel) return;
            var parts = String(vals[0]).split('-');
            var lo = Math.round(parseFloat(parts[0]) * 100);
            var hi = Math.round(parseFloat(parts[1]) * 100);
            /* ⚑ TRIM THE MENU FIRST, BEFORE ANY EARLY RETURN. This was the
             * bug in the first attempt: hideOutOfRange sat at the BOTTOM of
             * pick(), and pick() returns early whenever the card already shows
             * an in-range price - which is the common case. Plagron Alga opens
             * on Grow 100ml at £3.95, so under a £10 ceiling it returned
             * immediately and the £113.95 option stayed in the list.
             * Hiding is not conditional on needing to change the selection. */
            hideOutOfRange(sel, lo, hi);

            var cur = sel.options[sel.selectedIndex];
            var curC = cur ? parseInt(cur.getAttribute('data-cents'), 10) : 0;

            /* ⚑ A SIZE THE SHOPPER CHOSE STAYS WHILE THE RANGE ALLOWS IT (23 Sep
             * 2026). Every pass now starts from that choice, so it only needs
             * protecting here: switch it only if it falls outside the range. */
            if (c._bpUserSel !== undefined && curC >= lo && curC <= hi) return;

            /* ⚑ THIS EARLY RETURN USED TO FREEZE THE CARD FOR THE REST OF THE
             * SESSION, and it is the whole of the bug Finbar reported on 24
             * Aug: "put 40 - it works on filtering the variants. then increase
             * it to £50 - no change."
             *
             * At £40 a card showing £113.95 fell out of range, so pick() ran
             * and selected a variant under £40. At £50 that selection is still
             * in range, so the test below returned immediately and the card
             * kept the variant the £40 ceiling chose. Every ceiling after the
             * first was a no-op.
             *
             * ⚑ AND IT WAS INVISIBLE BECAUSE THE MINIMUM SITS ON THE PAGE
             * FLOOR. A max-only filter drops a product only if its CHEAPEST
             * variant is over the ceiling, and on base feeds almost every
             * product has a cheap 1L - so the card set barely moved between
             * £40 and £50 either. Nothing on screen changed at all.
             *
             * The guard now remembers WHICH range and direction it was
             * satisfied for. Same range, in-range price: still left alone, so
             * cards do not all jump to their smallest size the moment a filter
             * is touched. Range moved: picked again. */
            var sig = lo + ':' + hi + ':' + (priceDearestFirst ? 'd' : 'a');
            if (c._bpPickSig === sig && curC >= lo && curC <= hi && !priceDearestFirst) return;
            c._bpPickSig = sig;

            function cheapest(respectOthers, allowSoldOut) {
              var want = null, wantC = priceDearestFirst ? -1 : Infinity;
              Array.prototype.slice.call(sel.options).forEach(function (o) {
                var cents = parseInt(o.getAttribute('data-cents'), 10);
                if (!cents || cents < lo || cents > hi) return;
                if (!allowSoldOut && o.disabled) return;
                if (respectOthers) {
                  var ok = groups.every(function (g2) {
                    var chosen = state[g2.key] || [];
                    return !g2.matchOpt || !chosen.length || g2.matchOpt(o, chosen);
                  });
                  if (!ok) return;
                }
                if (priceDearestFirst ? cents > wantC : cents < wantC) { wantC = cents; want = o; }
              });
              return want;
            }
            var want = cheapest(true, false) || cheapest(true, true) ||
                       cheapest(false, false) || cheapest(false, true);
            /* ⚑ THE ATTRIBUTE WRITE IS NOT CONDITIONAL ON THE SELECT CHANGING,
             * and that condition was the bug Finbar reported on 24 Aug:
             * "when I hit 47 it goes back to filtering from £40 ... it's only
             * adding in the new product above the first search and not sorting
             * the entire set of results."
             *
             * restorePriceSpan() now resets data-bp-min to the product's FLOOR
             * before every pass. A card that already happened to display the
             * right variant then skipped this block, so its sort key stayed at
             * the floor - £3.95 for a range that starts at 1L - while the one
             * card that DID change variant got a real key and shot to the top.
             * One product moved, the rest sorted on their cheapest size. */
            if (want) {
              if (sel.value !== want.value) sel.value = want.value;   /* repainted by repaintSizes() */
              var picked = parseInt(want.getAttribute('data-cents'), 10);
              if (picked) { c.setAttribute('data-bp-min', picked); c.setAttribute('data-bp-max', picked); }
            }
          }
        });
      }
    }

    /* ⚑ ONE FACET AND ONE ONLY ON A ROOTCAT PAGE. Applied here, to the
     * finished list, so that nothing above has to know this mode exists and no
     * page that keeps its facets can be broken by it. The SORT is untouched -
     * he asked for the filtering to be simplified, not the ordering. */
    /* Water flow (or air output, or a filter's airflow) is what the product is
     * chosen on, so it sits straight under Category rather than after Brand,
     * where the push order left it. A page only ever has one of the three. */
    (function () {
      var i = -1;
      groups.forEach(function (g, j) { if (/^(flow|aout|cair)$/.test(g.key)) i = j; });
      if (i < 0) return;
      var fg = groups.splice(i, 1)[0], at = 0;
      groups.forEach(function (g, j) { if (/^(rootcat|subcat|band|ptype)$/.test(g.key)) at = j + 1; });
      groups.splice(at, 0, fg);
    })();
    if (ROOTCAT) groups = groups.filter(function (g) { return g.key === 'rootcat'; });

    /* ---- build the tray -------------------------------------------------- */
    var trayBody = root.querySelector('[data-bp-tray-body]');
    var tray = root.querySelector('[data-bp-tray]');
    var scrim = root.querySelector('[data-bp-scrim]');
    var state = {};

    groups.forEach(function (g) {
      state[g.key] = [];
      var d = document.createElement('details');
      d.className = 'hcs-bp__fgroup';
      g.det = d;
      /* ⚑ FIVE OR MORE OPTIONS AND THE GROUP STARTS CLOSED. Finbar, 19 Aug.
       * An open group with a dozen brands in it pushes every group below it
       * off the screen, so the tray reads as one long list and the shopper
       * never learns the others exist. A closed summary is a menu.
       *
       * ⚑ DUCT SIZE IS THE ONE EXCEPTION, BY NAME. There are seven duct
       * sizes and there will only ever be seven - it is a fixed vocabulary,
       * not a list that grows with the catalogue - and on a ventilation page
       * the duct is the FIRST thing a shopper filters on. Being over the
       * threshold is an accident of that vocabulary, not a sign the group is
       * unwieldy.
       *
       * Price is a range, not an option list, so the count does not apply. */
      /* `tent` joins `duct` as a fixed, first-filtered vocabulary: a tents page
       * exists to be filtered by footprint, so that group starts open. */
      var manyOpts = g.options && g.options.length >= 5 && g.key !== 'duct' && g.key !== 'tent' && g.key !== 'flow' && g.key !== 'aout' && g.key !== 'cair';
      if (g.open && !manyOpts) d.open = true;
      var sm = document.createElement('summary');
      sm.textContent = g.label;
      d.appendChild(sm);

      if (g.range) {
        /* ⛑ THE POUND SIGN IS A SEPARATE ELEMENT, NOT PART OF THE VALUE.
         * An <input type="number"> silently rejects any value it cannot parse,
         * so "£6" is not a value it can ever hold - typing the symbol in
         * would empty the box. It is painted over the field's left padding
         * instead, and is aria-hidden because the input already carries
         * "in pounds" in its own label. */
        /* ⚑ TWO RANGE INPUTS STACKED, NOT ONE. A single slider can only set one
         * end of a price range, and he asked for min AND max. The two tracks
         * are overlaid and only the thumbs take pointer events, which is what
         * lets both be dragged on the same line. The number boxes are the same
         * state by another route - typing in one moves the thumb and vice
         * versa - because a thumb is hard work on a phone for an exact figure. */
        var wrap = document.createElement('div');
        wrap.className = 'hcs-bp__range';
        wrap.innerHTML =
          '<div class="hcs-bp__range-nums">' +
            '<label><span>Min</span><span class="hcs-bp__range-cur"><i aria-hidden="true">\u00a3</i><input type="number" inputmode="numeric" class="hcs-bp__range-in" data-r="lo" min="' + g.lo + '" max="' + g.hi + '" value="' + g.lo + '" aria-label="Minimum price in pounds"></span></label>' +
            '<label><span>Max</span><span class="hcs-bp__range-cur"><i aria-hidden="true">\u00a3</i><input type="number" inputmode="numeric" class="hcs-bp__range-in" data-r="hi" min="' + g.lo + '" max="' + g.hi + '" value="' + g.hi + '" aria-label="Maximum price in pounds"></span></label>' +
          '</div>' +
          '<div class="hcs-bp__range-track">' +
            '<span class="hcs-bp__range-fill"></span>' +
            '<input type="range" data-r="lo" min="' + g.lo + '" max="' + g.hi + '" value="' + g.lo + '" aria-label="Minimum price">' +
            '<input type="range" data-r="hi" min="' + g.lo + '" max="' + g.hi + '" value="' + g.hi + '" aria-label="Maximum price">' +
          '</div>';
        d.appendChild(wrap);
        trayBody.appendChild(d);
        g.el = wrap;

        var fill = wrap.querySelector('.hcs-bp__range-fill');
        function readRange() {
          var lo = +wrap.querySelector('input[type=range][data-r=lo]').value;
          var hi = +wrap.querySelector('input[type=range][data-r=hi]').value;
          if (lo > hi) { var t = lo; lo = hi; hi = t; }
          return [lo, hi];
        }
        /* ⚑ NEVER REWRITE THE BOX THE SHOPPER IS TYPING IN. Finbar, 24 Aug:
         * "the text box is weird, you cant enter in a number easily and it
         * doesnt allow you to delete everything in the box."
         *
         * paint() ran on every keystroke and pushed the slider's value back
         * into BOTH number fields. Clear the box and paint instantly refilled
         * it; type "5" meaning 50 and the clamp rewrote it mid-word. The field
         * was fighting the person using it.
         *
         * The focused field is now left alone - it is the source of truth
         * while it has focus, and paint catches up on blur. */
        function paint() {
          var r = readRange();
          var span = g.hi - g.lo || 1;
          fill.style.left = ((r[0] - g.lo) / span * 100) + '%';
          fill.style.right = ((g.hi - r[1]) / span * 100) + '%';
          wrap.querySelectorAll('input[type=number]').forEach(function (n) {
            if (n === document.activeElement) return;
            n.value = n.getAttribute('data-r') === 'lo' ? r[0] : r[1];
          });
        }
        function commit() {
          var r = readRange();
          /* The whole span means "no filter", so the badge does not count it. */
          state[g.key] = (r[0] <= g.lo && r[1] >= g.hi) ? [] : [r[0] + '-' + r[1]];
          paint();
          apply();
        }
        /* ⚑ A NUMBER INPUT DOES NOT FIRE `change` UNTIL IT LOSES FOCUS, AND
         * THAT IS THE WHOLE BUG. Finbar, 24 Aug: "the price sorting slider
         * isn't working on sub cat pages to exclude variants over the price
         * limit."
         *
         * `commit()` is the only thing that writes the filter state and calls
         * apply(), and it was bound to `change` alone. Dragging the SLIDER
         * fires change on release, so the slider always worked - verified
         * live, 156 products to 154 with nothing over the ceiling left on
         * screen. But TYPING 49 into the Max box fires only `input`. The
         * shopper types a ceiling, watches nothing happen, and every card
         * carries on advertising its most expensive size.
         *
         * ⚑ IT LOOKED LIKE A BROKEN FILTER AND WAS ACTUALLY AN UNCOMMITTED
         * ONE - clicking anywhere else on the page would have applied it.
         *
         * Typing now commits on a short delay. ⚑ THE DELAY IS NOT COSMETIC:
         * committing on every keystroke means "49" filters to <=4 first, and
         * on a 156-product page that is a visible flash of the wrong result,
         * plus a pick() pass that reselects every card's variant twice. */
        var typeTimer = null;
        wrap.addEventListener('input', function (e) {
          if (e.target.type === 'number') {
            var side = e.target.getAttribute('data-r');
            var raw = e.target.value;
            var v = parseFloat(raw);
            paint();
            /* ⚑ AN EMPTY BOX IS "STILL TYPING", NOT ZERO. Treating it as a
             * value would snap the slider to the floor and refill the field. */
            if (raw === '' || isNaN(v)) return;
            wrap.querySelector('input[type=range][data-r=' + side + ']').value = Math.min(g.hi, Math.max(g.lo, v));
            clearTimeout(typeTimer);
            typeTimer = setTimeout(commit, 400);
            return;
          }
          paint();
        });
        /* Blur, Enter, and slider release all still commit at once - the
         * debounce is only there to survive the keystrokes in between. */
        wrap.addEventListener('change', function () {
          clearTimeout(typeTimer);
          commit();
        });
        g.reset = function () {
          wrap.querySelector('input[type=range][data-r=lo]').value = g.lo;
          wrap.querySelector('input[type=range][data-r=hi]').value = g.hi;
          paint();
        };
        paint();
        return;
      }

      g.options.forEach(function (o) {
        var lab = document.createElement('label');
        lab.className = 'hcs-bp__fopt';
        var cb = document.createElement('input');
        cb.type = 'checkbox';
        cb.value = o.value;
        cb.setAttribute('data-bp-fkey', g.key);
        var sp = document.createElement('span');
        /* A label written "Name \u00b7 detail" draws the detail muted on the
         * same line - the tent sizes. No other label carries a middle dot. */
        var lp = String(o.label).split(' \u00b7 ');
        sp.textContent = lp[0];
        if (lp[1]) {
          var sub = document.createElement('span');
          sub.className = 'hcs-bp__fopt-sub';
          sub.textContent = lp[1];
          sp.appendChild(document.createTextNode(' '));
          sp.appendChild(sub);
        }
        var n = document.createElement('span');
        n.className = 'hcs-bp__fopt-n';
        lab.appendChild(cb); lab.appendChild(sp); lab.appendChild(n);
        o.el = lab; o.cb = cb; o.n = n;
        d.appendChild(lab);
      });
      trayBody.appendChild(d);
    });

    if (!groups.length) {
      /* Nothing worth filtering - a page of five products with one brand and
       * one price band. Hide the control rather than offer an empty tray. */
      var fb = root.querySelector('[data-bp-filter-open]');
      if (fb) fb.hidden = true;
      if (tray) tray.hidden = true;
    } else {
      root.classList.add('hcs-bp--hasfilters');
      if (tray) tray.hidden = false;
      if (scrim) scrim.hidden = false;
    }
    /* ⚑ BOTH ATTRIBUTES, TOGETHER. `hidden` on this row means `visibility:
     * hidden` plus a reserved 60px, not `display: none` - the row has been
     * holding its own space since first paint so that revealing it moves
     * nothing (see assets/hcs-brand.css). `inert` is what kept the button and
     * the <select> out of the tab order while it was invisible, so it has to
     * go at the same moment or the controls render but cannot be used. */
    bar.hidden = false;
    bar.removeAttribute('inert');

    /* ---- the engine ------------------------------------------------------ */
    var sortSel = root.querySelector('[data-bp-sort]');
    var countEl = root.querySelector('[data-bp-filter-count]');
    var filterBtn = root.querySelector('[data-bp-filter-open]');

    function activeCount() {
      var n = 0;
      Object.keys(state).forEach(function (k) { n += state[k].length; });
      return n;
    }

    function passes(c) {
      return groups.every(function (g) {
        var vals = state[g.key];
        if (!vals.length) return true;
        return g.test(c, vals);
      });
    }

    /* Counts are computed with THIS group's own selection ignored, which is
     * what makes a facet list usable: ticking "Canna" should not drop every
     * other brand's count to zero. */
    function recount() {
      groups.forEach(function (g) {
        if (g.range) return;   /* a range has no per-value counts to show */
        g.options.forEach(function (o) {
          var n = cards.filter(function (c) {
            return groups.every(function (g2) {
              if (g2 === g) return g2.test(c, [o.value]);
              var vals = state[g2.key];
              return !vals.length || g2.test(c, vals);
            });
          }).length;
          o.n.textContent = n;
          o.el.classList.toggle('is-empty', n === 0);
        });
      });
    }

    /* ---- Size, on the pages that have one ---------------------------------
     * Finbar: "grow tents need sort by size."
     *
     * ⚑ THE OPTION IS ADDED ONLY IF THE CARDS CARRY `data-bp-area`, which the
     * spec card writes solely on a `range` page, from the floor area already
     * parsed out of the title by hcs-tent-dims. Same rule as every facet: it is
     * derived from what is on the page, so it can never appear on a page where
     * it would sort by nothing. Floor area in cm², so it orders identically to
     * m² without the rounding. */
    /* ⚑ EVERY EXTRA SORT IS OFFERED ONLY WHERE THE CARDS CARRY THE FIGURE.
     * Same rule as the facets: derived from what is on the page, so a sort can
     * never appear on a page where it would order by nothing. `data-bp-watt`,
     * `data-bp-ppf` and `data-bp-dim` are written by the spec card from the
     * product's own spec block, so an LED page gets power, light output and
     * fixture size, and a tent page gets floor area - without either knowing
     * about the other.
     *
     * ⚑ THE LABEL SAYS WHAT THE NUMBER IS, NOT WHAT THE SPEC IS CALLED.
     * "Light output" rather than "PPF": the figure is µmol/s either way, and a
     * shopper who does not know the acronym can still use the control. */
    [
      ['area', 'Tent size: smallest first', 'Tent size: largest first'],
      ['watt', 'Power: lowest first', 'Power: highest first'],
      ['ppf', 'Light output: lowest first', 'Light output: highest first'],
      ['dim', 'Fixture width: narrowest first', 'Fixture width: widest first']
    ].forEach(function (spec) {
      var key = spec[0];
      /* ⚑ `dim` AND `ppf` ARE LIGHTING FIGURES - the same tent `Size:` row
       * that put a Fixture size FACET on the tents page also put a "Fixture
       * size: smallest first" SORT there. A card only counts for those two
       * if its own type is a light. Floor area (`area`) is the tent's sort
       * and is untouched. */
      var has = cards.filter(function (c) {
        if (!c.getAttribute('data-bp-' + key)) return false;
        if (key === 'area') return true;
        if (key !== 'dim' && key !== 'ppf') return true;
        var t = (c.getAttribute('data-bp-type') || '').toLowerCase();
        return /grow lights|propagation > lights|led|lamp|hps|cdm|reflector|fixture|ballast|bulb/.test(t) && !TENT_SCOPE.test(t);
      }).length >= (key === 'area' ? 2 : 1);
      if (!has || !sortSel || sortSel.querySelector('[value="' + key + '-asc"]')) return;
      [[key + '-asc', spec[1]], [key + '-desc', spec[2]]].forEach(function (o) {
        var opt = document.createElement('option');
        opt.value = o[0]; opt.textContent = 'Sort by: ' + o[1];
        sortSel.appendChild(opt);
      });
    });

    function sortKey(c, mode) {
      /* ⚑ AN UNREADABLE FIGURE RETURNS null AND IS HANDLED IN THE COMPARATOR,
       * NOT PAPERED OVER WITH A BIG NUMBER. The first version returned Infinity
       * and the comment claimed that put unknowns last "in both directions".
       * That is simply wrong: Infinity is the LARGEST value, so a DESCENDING
       * sort leads with every product whose figure could not be read - the top
       * of "Light output: highest first" was fixtures with no stated output.
       * Caught by testing both directions rather than one. */
      var specSort = mode.split('-')[0];
      if (['area', 'watt', 'ppf', 'dim'].indexOf(specSort) !== -1) {
        var n = parseInt(c.getAttribute('data-bp-' + specSort), 10);
        return n > 0 ? n : null;
      }
      if (mode === 'area-asc' || mode === 'area-desc') {
        /* ⚑ A TENT WHOSE SIZE COULD NOT BE READ SINKS, IT DOES NOT LEAD. Two of
         * the fourteen grow tents state no dimensions in their title, so their
         * area is 0 - and 0 sorts FIRST under "smallest first", which put two
         * sizeless products at the top of a sort that exists to show size.
         * Infinity puts them last in both directions, which is where an
         * unanswered question belongs. */
        var a = parseInt(c.getAttribute('data-bp-area'), 10);
        return a > 0 ? a : null;
      }
      if (mode === 'price-asc' || mode === 'price-desc') return parseInt(c.getAttribute('data-bp-min'), 10) || 0;
      if (mode === 'title-asc' || mode === 'title-desc') return (c.getAttribute('data-bp-title') || '').toLowerCase();
      return 0;
    }

    /* =====================================================================
       ⚑ A FACET IS SHOWN ONLY WHERE IT DESCRIBES THE PRODUCTS IN VIEW
       =====================================================================
       Finbar, 6 Sep 2026, on the Plant Health parent page: "currently plant
       health is showing duct size ... duct size barely applies here and it
       shows the entire range for every selection."

       An audit of all 125 engine pages the same evening found the cause in
       the build rule, not the page: an attribute facet was BUILT the moment
       two cards carried it, however large the page. Plant Health's Duct size
       came from two replacement filter sleeves among 105 products; Tools &
       Accessories had it at 8 of 186, Hydroponic Systems at 2 of 242, Cube
       size sat on Growing Medium at 2 of 33 and Propagation at 2 of 123, and
       Growing medium appeared on Tools with ONE carrier (one card carrying
       three media satisfies "two distinct values").

       THE RULE: an attribute facet - anything with a `carrier` test, so not
       Category, Brand or Price - is shown only while the cards
       that carry it are at least COVERAGE of the cards in view, at least two
       of them, spread over at least two of its values, and at least one value
       would exclude a carrier. Otherwise the group is hidden, and any
       selection it held is cleared, because a filter the shopper cannot see
       must not be hiding products.

       ⚑ "IN VIEW" IS THE POINT, AND IT IS WHY THIS RUNS ON EVERY apply()
       RATHER THAN ONCE AT BUILD. The base for each group is the cards that
       pass every OTHER group's selection - the same basis recount() uses -
       so on a parent page Duct size is absent at 68 of 244 but returns the
       moment Category narrows to Extractor fans, where it is 27 of 28. A
       parent page cannot be as precise as a sub-category page; this lets it
       become one as the shopper narrows.

       ⚑ A QUARTER, FROM THE AUDIT, NOT FROM TASTE. Every facet that was
       plainly wrong sat at 1-16% of its page; every facet that was plainly
       right sat at 29% or above (G.A.S. duct 29%, Athena bottle size 35%,
       LED fixture size 44%); the two borderline cases - odour control's duct
       sizes at 23% (ozone units among gels and sprays) and Rockwool's cube
       size at exactly 25% - fall the way a shopper would want.

       The loop re-runs while anything changed, because clearing one group's
       selection widens the base every other group is judged on. */
    var COVERAGE = 0.25;
    function gate() {
      var changed = true, guard = 0;
      while (changed && guard++ < 8) {
        changed = false;
        groups.forEach(function (g) {
          if (!g.carrier || !g.det) return;
          var base = cards.filter(function (c) {
            return groups.every(function (g2) {
              if (g2 === g) return true;
              var vals = state[g2.key];
              return !vals.length || g2.test(c, vals);
            });
          });
          var carriers = base.filter(g.carrier);
          var ok = carriers.length >= 2 && carriers.length >= base.length * COVERAGE;
          if (ok) {
            var live = g.options.filter(function (o) {
              return carriers.some(function (c) { return g.test(c, [o.value]); });
            });
            ok = live.length >= 2 && carriers.some(function (c) {
              return live.some(function (o) { return !g.test(c, [o.value]); });
            });
          }
          if (!ok && state[g.key].length) {
            state[g.key] = [];
            g.options.forEach(function (o) { if (o.cb) o.cb.checked = false; });
            changed = true;
          }
          g.det.hidden = !ok;
          /* The medium chip rail is a shortcut into this one group; it goes
           * with it, or a chip would set a filter the tray does not show. */
          if (g.key === 'media' && chipBar) chipBar.hidden = !ok;
        });
      }
    }

    function apply() {
      var mode = sortSel ? sortSel.value : 'rank';
      gate();
      /* ⚑ THE VARIANT PICK HAS TO HAPPEN BEFORE THE SORT READS A PRICE.
       * Selecting the 150mm variant rewrites data-bp-min; sort first and the
       * page orders on the old price and looks arbitrary. */
      /* ⚑ RESTORE BEFORE PICKING, EVERY TIME. If the shopper widens the
         ceiling from £10 to £60 the previously hidden sizes have to come back
         before the new range is applied, or the range only ever narrows. */
      restoreAllOptions();
      restorePriceSpan();
      var preSizes = restoreSizes();
      priceDearestFirst = (mode === 'price-desc');
      groups.forEach(function (g) {
        if (!g.pick) return;
        var vals = state[g.key];
        if (!vals.length) return;
        cards.forEach(function (c) { if (g.test(c, vals)) g.pick(c, vals); });
      });
      if (mode === 'price-desc') pickDearest();
      if (mode === 'ppf-desc') pickByPpf(true);
      if (mode === 'ppf-asc') pickByPpf(false);
      repaintSizes(preSizes);
      syncDisplayedPrice();

      var filtered = activeCount() > 0;
      var collapse = filtered || mode !== 'rank';

      var shown = cards.filter(passes);

      if (collapse) {
        var list = shown.slice();
        if (mode !== 'rank') {
          list.sort(function (a, b) {
            var ka = sortKey(a, mode), kb = sortKey(b, mode);
            /* ⚑ NO AVAILABILITY IN THE ORDER - Finbar, 7 Sep 2026. A sorted
             * list is ordered purely on the figure being sorted; an
             * out-of-stock product sits wherever its price or size puts it.
             * See the same note in hcs-brand.js. Do not reintroduce it.
             *
             * ⚑ UNKNOWN ALWAYS SINKS, WHICHEVER WAY THE SORT RUNS. A product
             * whose figure could not be read is not "very small" or "very
             * large" - it is unanswered, and it belongs at the bottom of a
             * sort that exists to compare that figure. */
            if (ka === null && kb === null) return 0;
            if (ka === null) return 1;
            if (kb === null) return -1;
            if (ka < kb) return mode.indexOf('-desc') !== -1 ? 1 : -1;
            if (ka > kb) return mode.indexOf('-desc') !== -1 ? -1 : 1;
            return 0;
          });
        }
        var frag = document.createDocumentFragment();
        list.forEach(function (c) { c.hidden = false; frag.appendChild(c); });
        flat.appendChild(frag);
        cards.forEach(function (c) { if (list.indexOf(c) === -1) c.hidden = true; });
        flat.hidden = false;
        root.classList.add('hcs-bp--flat');
        scope.querySelectorAll('.hcs-bp__band').forEach(function (b) {
          if (b.id === 'bp-about') return;
          b.hidden = !b.querySelector('[data-bp-card]:not([hidden])');
        });
      } else {
        /* Put every card back where it started, in its original order. */
        var homes = [];
        cards.forEach(function (c) { if (homes.indexOf(c._bpHome) === -1) homes.push(c._bpHome); });
        homes.forEach(function (h) {
          var mine = cards.filter(function (c) { return c._bpHome === h; })
                          .sort(function (a, b) { return a._bpIndex - b._bpIndex; });
          var f2 = document.createDocumentFragment();
          mine.forEach(function (c) { c.hidden = false; f2.appendChild(c); });
          h.appendChild(f2);
        });
        flat.hidden = true;
        root.classList.remove('hcs-bp--flat');
        scope.querySelectorAll('.hcs-bp__band').forEach(function (b) { b.hidden = false; });
      }

      root.classList.toggle('hcs-bp--empty', shown.length === 0);
      if (countEl) countEl.textContent = activeCount();
      if (filterBtn) filterBtn.classList.toggle('is-on', activeCount() > 0);
      recount();
      syncChips();
    }

    /* ---- view ------------------------------------------------------------
     * ⚑ DELETED 19 Aug 2026, the same day it shipped. Finbar: "delete list
     * view only tile view from now on."
     *
     * It was not just a preference being withdrawn. The list CSS styled the
     * grid card and the spec card but NOT the spares link-card, so in list
     * view a horizontal slider became a vertical stack and each spares card
     * rendered at full width with its 1:1 image intact - measured at
     * 1250x1250 on the Quest page, one product filling the screen. That is
     * what he screenshotted as "way too big".
     *
     * The localStorage key `hcs-bp-view` is deliberately NOT read or written
     * any more. Anyone who left the site in list view simply gets tiles. */

    /* ---- the medium chips drive the same state --------------------------- */
    /* The chip rail on the nutrient pages predates the tray. Left alone it
     * would set style.display on cards while the tray set `hidden`, so the two
     * would silently fight. It is now a shortcut into the Medium facet. */
    var chipBar = root.querySelector('[data-bp-media-filter]');
    function syncChips() {
      if (!chipBar) return;
      var sel = state.media || [];
      chipBar.querySelectorAll('[data-med]').forEach(function (ch) {
        var v = ch.getAttribute('data-med');
        var on = v === 'all' ? sel.length === 0 : (sel.length === 1 && sel[0] === v);
        ch.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }
    if (chipBar) {
      chipBar.addEventListener('click', function (e) {
        var ch = e.target.closest('[data-med]');
        if (!ch) return;
        var v = ch.getAttribute('data-med');
        state.media = v === 'all' ? [] : [v];
        trayBody.querySelectorAll('[data-bp-fkey="media"]').forEach(function (cb) {
          cb.checked = state.media.indexOf(cb.value) !== -1;
        });
        apply();
      });
    }

    /* ---- wiring ---------------------------------------------------------- */
    trayBody.addEventListener('change', function (e) {
      var cb = e.target;
      if (!cb.matches || !cb.matches('[data-bp-fkey]')) return;
      var k = cb.getAttribute('data-bp-fkey');
      var i = state[k].indexOf(cb.value);
      if (cb.checked && i === -1) state[k].push(cb.value);
      if (!cb.checked && i !== -1) state[k].splice(i, 1);
      apply();
    });

    if (sortSel) sortSel.addEventListener('change', apply);

    function openTray(open) {
      if (!tray) return;
      tray.classList.toggle('is-open', open);
      if (scrim) scrim.classList.toggle('is-open', open);
      if (filterBtn) filterBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.documentElement.style.overflow = open && window.innerWidth < 990 ? 'hidden' : '';
      if (open) { var f = tray.querySelector('input'); if (f) f.focus(); }
      else if (filterBtn) filterBtn.focus();
    }
    if (filterBtn) filterBtn.addEventListener('click', function () { openTray(!tray.classList.contains('is-open')); });
    root.querySelectorAll('[data-bp-filter-close]').forEach(function (b) {
      b.addEventListener('click', function () { openTray(false); });
    });
    if (scrim) scrim.addEventListener('click', function () { openTray(false); });
    /* ⚑ ON DESKTOP THIS MUST NOT CLOSE ANYTHING. Finbar, 24 Aug: "we need a
       show results button on desktop - currently its only on mobile." Below
       990px the tray is a pop-out and the button dismisses it. From 990px the
       tray IS the left column, so dismissing it would take the filters off the
       page. There it commits whatever is half-typed and walks the shopper to
       the results instead. */
    var applyBtn = root.querySelector('[data-bp-filter-apply]');
    if (applyBtn) applyBtn.addEventListener('click', function () {
      if (window.innerWidth < 990) { openTray(false); return; }
      /* Clicking the button has already blurred the Max box, which fires
         `change` and commits - this is the belt to that pair of braces. */
      apply();
      var target = flat && !flat.hidden ? flat : scope;
      if (target && target.getBoundingClientRect) {
        var top = target.getBoundingClientRect().top + window.pageYOffset -
                  (parseInt(getComputedStyle(document.documentElement)
                    .getPropertyValue('--hcs-header-min'), 10) || 0) - 12;
        window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
      }
    });
    root.querySelectorAll('[data-bp-filter-clear]').forEach(function (b) {
      b.addEventListener('click', function () {
        Object.keys(state).forEach(function (k) { state[k] = []; });
        trayBody.querySelectorAll('[data-bp-fkey]').forEach(function (cb) { cb.checked = false; });
        /* ⚑ A RANGE HAS NO CHECKBOXES TO UNTICK. Clearing the state alone would
         * leave both thumbs where the shopper dragged them while the page
         * showed everything - the control saying one thing and the grid
         * another. */
        groups.forEach(function (g) { if (g.reset) g.reset(); });
        if (sortSel) sortSel.value = 'rank';
        apply();
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && tray && tray.classList.contains('is-open')) openTray(false);
    });

    apply();
  }

  /* ---- the control row's sticky offset ----------------------------------
   * ⚑ THERE IS NO LONGER ANY JAVASCRIPT HERE, AND THAT IS THE FIX.
   *
   * Finbar, 10 Sep 2026, from a phone: "the filter bar not snapping to the top
   * cleanly and getting stuck half way in the screen."
   *
   * This used to be a scroll listener that re-measured the header's bottom edge
   * on every scroll event and wrote it to a custom property that the row's
   * `top` read. iOS Safari runs momentum scrolling on the compositor and defers
   * main-thread style and layout until the flick settles, so during the flick
   * the listener does not run and the variable keeps its last value - at the
   * top of the page, the FULL header's bottom. Measured at 393px with the
   * listeners starved: frozen at 166px while the bar sits at 60px, so the row
   * landed 106px too low and stayed there. Writing a sticky element's
   * `top` mid-scroll also invalidates Safari's tile cache, which is why the
   * grid below it came back blank in his screenshot.
   *
   * ⚑ THE ROW'S OFFSET IS NOW A CONSTANT IN CSS - `--hcs-header-min`, the bar
   * alone, written once by setHeaderHeight() in sections/header.liquid. See the
   * long note at section 10a of hcs-brand.css for why it does not need to track
   * the header at all.
   *
   * ⚑ DO NOT REINTRODUCE A SCROLL LISTENER HERE. Both versions of this that
   * existed - rAF-throttled, then scroll-driven - froze at a stale value, just
   * in different conditions. A sticky offset must not depend on JS running
   * during a scroll.
   * -------------------------------------------------------------------- */

  /* ---- parent pages: every product, not just the first 250 ---------------
   * Finbar, 6 Sep 2026: "every collection page to now show every product
   * within the collection". Liquid renders 250 per page (its ceiling), so a
   * parent such as Nutrients & Boosters (737) arrives as page 1 plus a server
   * pagination nav. Before the tray indexes the cards, every other page is
   * fetched through the section rendering API, its cards are wired by
   * hcs-brand.js and appended to the grid, and the nav is hidden - so the
   * Filter and Sort see the whole collection, which is the whole point.
   *
   * ⚑ THIS RUNS BEFORE init(), NOT AFTER. init() reads the cards ONCE and
   * builds every facet from them; re-running it would bind every control
   * twice. Merging first keeps init untouched.
   *
   * If a fetch fails the page is still complete: init() runs on what is
   * there and the server nav stays visible with its real links. */
  function mergePages(root) {
    var nav = root.querySelector('[data-bp-morepages]');
    if (!nav || !window.fetch || !window.DOMParser) return Promise.resolve();
    var sectionId = nav.getAttribute('data-bp-section');
    var links = Array.prototype.slice.call(nav.querySelectorAll('a[data-bp-page]'));
    var grid = root.querySelector('[data-bp-bands] [data-bp-sortgrid]');
    if (!sectionId || !links.length || !grid) return Promise.resolve();
    nav.classList.add('is-loading');
    var jobs = links.map(function (a) {
      var url = a.getAttribute('href');
      url += (url.indexOf('?') === -1 ? '?' : '&') + 'section_id=' + encodeURIComponent(sectionId);
      return fetch(url, { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var g = doc.querySelector('[data-bp-bands] [data-bp-sortgrid]');
          var cards = g ? Array.prototype.slice.call(g.children) : [];
          return { page: parseInt(a.getAttribute('data-bp-page'), 10) || 0, cards: cards };
        });
    });
    return Promise.all(jobs).then(function (pages) {
      pages.sort(function (x, y) { return x.page - y.page; });
      var holder = document.createElement('div');
      pages.forEach(function (pg) { pg.cards.forEach(function (c) { holder.appendChild(document.importNode(c, true)); }); });
      /* wire the new cards while they are still outside the grid */
      if (window.hcsBrandBoot) { try { window.hcsBrandBoot(holder); } catch (e) {} }
      while (holder.firstChild) grid.appendChild(holder.firstChild);
      /* one order across all the pages: rank (staples 1..3, then the sellers'
       * order), then the type mix of the top line */
      if (window.hcsBrandSortGrid) { try { window.hcsBrandSortGrid(grid); } catch (e) {} }
      nav.hidden = true;
      nav.classList.remove('is-loading');
    }).catch(function () {
      nav.classList.remove('is-loading');
    });
  }

  function boot(ctx) {
    (ctx || document).querySelectorAll('.hcs-bp').forEach(function (root) {
      mergePages(root).then(function () { init(root); });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else { boot(document); }
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
